export const CATEGORIES = [ 
     
   {
		id: 0,
		navTitle: 'Discover Crystalbrook Bailey',
		urlSegment: 'hotel',
		title: "Well isn’t this a pleasure, I’m Crystalbrook Bailey.",
		categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrook-collection-bailey.mp4',
		categoryBg: 'https://cdn.experienceoz.com.au/assets/images/bailey/misc/pattern-bg.png',
		linkInfo: "This isn’t what you’d expect from the neighbourhood. It's about seeing, feeling, touching, and getting lost in the details. Art. Conservations. Places. Do things your way. If there’s anything we can help with, please don’t be shy, chat to our Experience Curators.",
		linkText: 'Discover Crystalbrook Bailey',
		linkAvatar: 'https://cdn.experienceoz.com.au/assets/images/bailey/home/thumb/hotel-1.jpg',
		categoryHeadImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/bailey/hotel/header/bailey-2.png',
		subCategories: [
			{
				subId: 0,
				subUrlSegment: 'restaurants',
				subTitle: 'Food & Drink',
				subDescription: 'Transport your tastebuds to the rugged Australian outback at CC’s Bar and Grill, or take a quick trip to Mexico and ablaze your senses at Pachamama. Relish the warm ambience of local surroundings and savour a bottle of red or a cocktail (or two) at one of our exemplary on-site bars. View our on-site restaurants and bars here. ',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-6.png',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/thumbnails/restaurants-1.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'ccs-bar-grill',
						activityTitle: "CC's Bar & Grill",
						activityInfoBlocks: [
							"Drawing inspiration from Crystalbrook Station and the ruggedness of the Australian outback, CC's Bar and Grill is redefining the traditional steakhouse.",
						],
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-8.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-8.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-9.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-10.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-11.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-12.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-13.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/ccs-bar-grill/ccs-bar-grill-14.jpg',
			  			],
			  			activityRestaurantLogo: 'https://cdn.experienceoz.com.au/assets/images/bailey/logo/ccs-bar-grill.png',
			  			activityRestaurantInfo: [
							"Famous for its steak, which comes directly from Crystalbrook Station, CC’s celebrates the best of Australian produce. The stellar menu is derived from quality, fresh harvest that befits the earthy tone of the restaurant. Local ingredients and the finest beef are used to create the hearty, flavoursome dishes that offer exhilaration with every bite.",
							'The specialty built hot grill is also a winner, dishing up chargrilled bliss night after night.',
							'Of course, any meal wouldn’t be complete without the perfect beverage companion. You’ll be spoiled for choice with a wine selection from around the world and cocktails as delicious as they are pretty.',
							'As far as we’re concerned, CC’s Bar and Grill ticks all the right boxes.',
			  			],
			  			activityRestaurant: [
			  				'Steakhouse',
			  			],
					},
					
					{
						actId: 1,
						actUrlSegment: 'pachamama',
						activityTitle: "Pachamama",
						activityInfoBlocks: [
							"From Barcelona to Buenos Aires, Lisbon to Lima, Pachamama is a sophisticated and stylish fusion of Latin flavours that’s as colourful, bountiful and passionate as Pachamama (Earth Mother) herself. See, be seen and celebrate with friends and visitors from near and far with a rooftop Caipirinha or a pre-dinner Pisco Sour, then embark on a culinary cultural journey.",
						],
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-7.png',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-7.png',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-8.png',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/pachamama/pachamama-6.jpg',
			  			],
			  			activityRestaurantLogo: 'https://cdn.experienceoz.com.au/assets/images/bailey/logo/colada.png',
			  			activityRestaurantInfo: [
							"The menu is jam-packed with flavour and deliciousness, letting authentic Latin influences shine through with every bite.",
							'All that feasting calls for a drink (or two) and there’s an impressive selection of refreshing ciders and cocktails to choose from.',
			  			],
			  			activityRestaurant: [
			  				'Mexican Fiesta',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'arte-wine-bar',
						activityTitle: "Arte Wine Bar",
						activityInfoBlocks: [
							"A bespoke, sustainable bar in the heart of Cairns that feels distinctly like your corner store locale. A warm and inviting neighbourhood wine bar, where you’re on a first name basis with the bartender, who coincidentally knows your favourite drop by region. Brandishing an ever-changing array of boutique bio-dynamic Australian wines and international wines - by the glass or bottle - no two days will be alike, with new wine varieties to explore upon each return visit.",
						],
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-1.png',
						activityImages: [
							'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-1.png',
							'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-2.png',
							'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-3.png',
							'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-4.png',
							'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/restaurants/arte/arte-5.png',
						],
						activityRestaurantLogo: 'https://cdn.experienceoz.com.au/assets/images/bailey/logo/arte.png',
						activityRestaurantInfo: [
							"The artisan deli-style menu is designed to complement and celebrate fresh, local produce and is best enjoyed in good company.",
							'Walk ins welcome, or speak to our Crystalbrook Bailey curators.',
						],
						activityRestaurant: [
							'Wine Bar',
						],
					},
				],
			},

			{
		   	subId: 1,
				subUrlSegment: 'art-at-bailey',
   			subTitle: 'Art At Crystalbrook Bailey',
   			subDescription: "At Crystalbrook Bailey, we don’t think art can be neatly defined. Art surrounds us. In everything we see, taste, smell, touch and hear. Crystalbrook Bailey celebrates art of every description – music, dance, food, architecture, painting, sculpture, literature, film…we love it all. Our goal at Crystalbrook Bailey is to make art accessible, inclusive and empowering. We see art as a powerful tool to break down barriers, provoke constructive thought, encourage empathy and question our own prejudices.",
				subImage: 'https://cdn.experienceoz.com.au/assets/images/hotel/header/art-at-bailey.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/thumbnails/art.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'jacqueline-scotcher',
						actQrCode: '',
						activityTitle: 'Jacqueline Scotcher',
						activityOperator: 'Art At Crystalbrook Bailey',
						activityInfo: "Jacqueline’s creative practice is centred on investigating landscapes, how particular environments make her feel and the significance of place-making. Experiences of moving through various natural terrains are expressed through layered abstract paintings. Having lived in Cairns for eight years, the region has dominated the subject matter of recent work. This culminated in PhD research based on walking, painting and place in the wet tropics of Far North Queensland. Her doctorate was completed through James Cook University, where she is a lecturer in creative arts. Jacqueline has exhibited in several solo exhibitions, including at the Tanks Arts Centre, the Cairns Regional Gallery, KickArts Contemporary Arts Cairns and in Brisbane. Many of her paintings have been acquired into private collections and her practice is featured in the current Queensland senior visual art syllabus.",
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/art/jacqueline-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/art/jacqueline-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/art/jacqueline-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/art/jacqueline-3.jpg',
			  			],
					},

					{
						actId: 1,
						actUrlSegment: 'natasha-davui',
						activityTitle: 'Natasha Davui',
						activityInfo: "Natasha Davui is a descendant of the Gunggari and Irukandji Djabugay Aboriginal peoples. The Gunggari people are from the Maranoa River region of South West Queensland and have historical links to the Aboriginal communities of Woorabinda and Cherbourg. The Irukandji Djabugay people's traditional homelands stretch across the Barron River region in Far North Queensland. Natasha's artwork is inspired by the natural beauty of the tropical rainforest and reef environments around Cairns.",
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/art/natasha-1.jpg',
			  			activityImages: [
							'https://cdn.experienceoz.com.au/assets/images/hotel/art/natasha-1.jpg',
							'https://cdn.experienceoz.com.au/assets/images/hotel/art/natasha-2.jpg',
							'https://cdn.experienceoz.com.au/assets/images/hotel/art/natasha-3.jpg',
			  			],
					},
				],
			},

			{
		   	subId: 2,
				subUrlSegment: 'bailey-recommends',
   			subTitle: "Crystalbrook Bailey Recommends",
   			categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
   			subDescription: 'See North Queensland through a local’s eyes. Find all the best bars, restaurants, shopping locations and hidden gems at your fingertips with personal recommendations from your lobby ambassador.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/hotel/header/recommends.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/bailey/hotel/thumbnails/recommend-2.png',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'rusty-markets',
						activityTitle: 'Rusty’s Markets',
						activityInfo: 'As the Giant Prawn is to Ballina, Rusty’s Markets is Cairns to a tee. Smack bang in the centre of town, these hawker-style markets operate every Friday – Sunday and are renowned for exotic produce (dragon fruit and purple mangosteens, anyone?) and over a hundred vibrant stalls with everything from flowers and cheese, coffee and chocolate, breads and local charcuterie as well as clothes and trinkets.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/rustys/rustys-2.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/rustys/rustys-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/rustys/rustys-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/rustys/rustys-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/rustys/rustys-4.jpg',
			  			],
					},

					{
						actId: 1,
						actUrlSegment: 'behana-gorge',
						activityTitle: 'Behana Gorge',
						activityInfo: '',
						activityInfoBlocks: [
							'Take a hike into the famous Cairns Pyramid mountain to beautiful Behana Gorge. This Cairns water supply flows all year round with no rest (for the wickedly beautiful). Behana Gorge a perfect vision of tropical scenery, with the whole of the gorge lined by giant granite boulders. Jumping into the water becomes an option for the adventurous. Take a moment to relax, close your eyes and listen to the wildlife, the sounds of the rainforest along with the mystic waterfalls flowing and you will know that you are in paradise.',
						],
						activityHowto: 'How to get there: Head south of Cairns past Gordonvale and look for a sign called Behana Gorge Road. Keep following this road all the way along through canefields until you come to the car park. The walking track takes about 45 minutes and there are several steep inclines so only go if you’re reasonably fit (it’s too far for young children to walk).',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/behana-gorge/behana-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/behana-gorge/behana-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/behana-gorge/behana-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/behana-gorge/behana-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/behana-gorge/behana-4.jpg',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'fairy-falls',
						activityTitle: 'Fairy Falls',
						activityInfo: 'Tucked away in the dense rainforest is a picturesque waterfall as magical as its name. Some rock hopping is required to reach this natural plunge pool, but the end result is definitely worth it.',
						activityHowto: 'How to get there: The track begins in the scrub on the left side of another popular swimming spot Crystal Cascade’s carpark in the northern Cairns suburb of Redlynch. Pretending you’re hunting for treasure, as you most certainly are, to find the pathway you must turn your back to the Crystal Cascades’ carpark, head into the forest where there is an opening between the trees. Keep the creek on your right, climb over boulders until you reach the most beautiful tranquil deep plunge pool.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/fairy/fairy-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/fairy/fairy-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/fairy/fairy-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/fairy/fairy-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/fairy/fairy-4.jpg',
			  			],
					},

					{
						actId: 3,
						actUrlSegment: 'josephine-falls',
						activityTitle: 'Josephine Falls',
						activityInfo: 'Of all the waterfalls in the region (and there’s a few!), Josephine Falls is not only one of the prettiest, but also one of the most fun! Swim in the crystal-clear waters, play in the cascade over smooth rocks that make a natural slippery slide for kids (and kids at heart) and relax on the sandy beach as the gentle breeze rustles flows through the overhead rainforest canopy.', 
						activityHowto: 'How to get there: Approximately 75 km south of Cairns is a little country town called Miriwinni. Take the turn off to Mount Bartle Frere, the highest mountain in Queensland, and you will then just need to follow the signs for around 8 kilometres to Josephine Falls.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/josephine-falls/josephine-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/josephine-falls/josephine-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/josephine-falls/josephine-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/josephine-falls/josephine-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/josephine-falls/josephine-4.jpg',
			  			],
					},
					{
						actId: 4,
						actUrlSegment: 'mossman-gorge',
						activityTitle: 'Mossman Gorge',
						activityInfoBlocks: [
							'Mossman Gorge, part of the Daintree National Park, is home to crystal-clear waters that flow over large granite boulders in the Mossman River gorge. Dense rainforests line steep mountainsides from the river banks keeping this spot secluded and cool all year round. An elevated boardwalk takes explorers through the lower rainforest canopy along the riverside, while more adventurous visitors can cross the Rex Creek suspension bridge and enjoy the 2.4-kilometre Rainforest circuit track through lush rainforest.',
						],
						activityDescription: '',
						activityHowto: 'How to get there: Just over an hour north of Cairns, follow the directions to Mossman. Mossman Gorge turnoff is well signed, taking you to the Mossman Gorge Centre. From there, a courtesy bus will ferry you to the start of the boardwalk.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-4.jpg',
			  			],
					},

					{
						actId: 5,
						actUrlSegment: 'mount-bartle-frere',
						activityTitle: 'Mount Bartle Frere',
						activityInfoBlocks: [
							'At 1622m above sea level, Bartle Frere is the highest point in Queensland and the second highest elevation gain in Australia, meaning this hike comes with some seriously good hiking cred and a sense of accomplishment.',
							'There are two main sections to the track, in the rainforest and above the rainforest in the boulder field. The rainforest section is wet muddy and steep and probably accounts for about 2/3 of the track. Expect to be on the trail anywhere from 6-8 hours to reach the summit, so make sure you plan well so you’re not depleted of daylight on your return journey.',
						],
						activityHowto: 'How to get there: Head south along the Bruce Highway away from Cairns until you come to Miriwinni. Turn off near here and follow the signs to the Josephine Falls National Park.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-bartle-frere/bartle-5.jpg',
			  			],
					},

					{
						actId: 6,
						actUrlSegment: 'mount-baldy',
						activityTitle: 'Mount Baldy',
						activityInfoBlocks: [
							'Cracking good views of Atherton Tablelands and surrounding farmlands, with the tip of Walsh’s Pyramid in the distance. Mount Baldy peak is 1017m above sea level and the walk rises 320m over two kilometres to the summit point. The narrow path is obvious, but the rough rocky surface makes the climb strenuous. The climb up Mt Baldy is steep in sections, but the marked track and stone stairs is a favourite for fitness-loving locals who enjoy a quick view of Tinaroo Dam at the top before scampering back down.',	
						],
						activityHowto: 'How to get there: Turn off the Atherton to Herberton road onto Rifle Range Road. Turn left at Newell Street at the gun club sign on the corner. The Mount Baldy car park and the start of the walk are 20m further along this road.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mount-baldy/baldy-5.jpg',
			  			],
					},

					{
						actId: 7,
						actUrlSegment: 'the-pyramid',
						activityTitle: 'The Pyramid',
						activityInfoBlocks: [
							'A rapid climb, spectacular views, sweeping sugar cane fields… it’s views like these that we’re certain inspired GangaJang lyrics. Not for the faint-hearted. this granite prism rises 922m to create a steep 6km return hike. Although a challenging climb, proudly standing on the peak with a view across the Wooroonooran National Park and beyond makes the jelly legs totally worth it. Human mountain goats can sign up for the annual ‘Great Pyramid Race’ in August, which tracks across Gordonvale, up the mountain and down again.',
						],
						activityHowto: 'How to get there: Drive south of Cairns to Gordonvale along the Bruce Highway. Just south of Gordonvale you will cross a river. Turn right a few hundred metres after the bridge into Moss Road and follow to the carpark on your left.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/the-pyramid/pyramid-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/the-pyramid/pyramid-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/the-pyramid/pyramid-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/the-pyramid/pyramid-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/the-pyramid/pyramid-4.jpg',
			  			],
					},

					{
						actId: 8,
						actUrlSegment: 'devils-thumb',
						activityTitle: 'Devil’s Thumb',
						activityInfoBlocks: [
							'The Devil’s Thumb trail, just north of Mossman, is not for everyone. Although well marked, the trail has steep ascents and slippery surfaces and walkers must be prepared for rock scrambling in places. Only experienced bushwalkers with above average fitness should attempt this trail. At 10.6KM and 1020m elevation, give yourself eight hours to complete. Highlights include the large coral fern patch and, of course, the summit itself.',							
						],
						activityHowto: 'How to get there: The trail begins in the Whyanbeel Valley at Little Falls Creek about 17 km north of Mossman, which is 80 km north of Cairns along the Captain Cook Highway. Pass the Karnak Playhouse, then follow the signs to the start of the walking track.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-1.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-3.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-4.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/devils-thumb/devils-thumb-5.jpg',	
			  			],
					},
				],
			},

			{
				subId: 3,
				subUrlSegment: 'dine-around',
				subTitle: 'Dine Around with Crystalbrook',
				subDescription: "Then charge it all back to your room. As a guest of a Crystalbrook Collection hotel or resort in Cairns, you get to enjoy more than just the hotel you booked. With three five-star hotels and resorts, nine restaurants and bars and Eléme Day Spa (located at Crystalbrook Riley and Crystalbrook Flynn) all within just 500m (a five-minute walk!) of each other, we want you to experience them all! Dine around at any of our restaurants in Cairns then charge it all back to your room. Go on, enjoy all that we have to offer!",
				subImage: 'img/food-and-drink.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/thumbnails/dine-around.png',
				activities: [
				],
				bigImage: "https://cdn.experienceoz.com.au/assets/images/hotel/header/dine-around.png"
			},	
		],
	},
   
   	// Location Based items
	{
	    id: 1,
	    navTitle: 'Discover Cairns',
		urlSegment: 'location',
		title: 'Discover Cairns',
		categoryBg: 'https://cdn.experienceoz.com.au/assets/images/bailey/misc/pattern-bg.png',
		linkHeading: 'Explore What Cairns has to offer',
		linkInfo: 'Cairns is the perfect base to explore both the Great Barrier Reef and the Daintree Rainforest. Travel like a local and find the best beaches, waterfalls, restaurants, shopping, nightlife and cultural attractions for a memorable stay in Tropical North Queensland.',
		linkText: 'Discover Cairns',
		linkAvatar: 'https://cdn.experienceoz.com.au/assets/images/bailey/home/thumb/cairns.jpg',
		linkImages: [
	        'https://images.unsplash.com/photo-1533094588965-900f4014f4c5?ixlib=rb-0.3.5&s=49b6ccee9afe4e09eb42c013c27cc731&auto=format&fit=crop&w=3900&q=80',
	    ],
	    categoryHeadImage: 'https://cdn.experienceoz.com.au/assets/images/cairns/home-image.jpg',
	    subCategories: [
	    	{
	    		subId: 0,
				subUrlSegment: 'beaches',
				subTitle: 'Beaches',
				subInfo: '',
				subDescription: 'Palm tree lined beaches and crystal clear waters can be found in North Queensland. Find a shady spot and curl up with a good book, swim in the cool waters or soak in the postcard worthy views. Here are a list of the top 5 beaches near Cairns but let’s be honest all Tropical North Queensland beaches are instagrammable!',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/cairns/header/beach.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/thumbnails/thumb-beach.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'nudey-beach',
						activityTitle: 'Nudey Beach, Fitzroy Island',
						activityInfo: 'While this beach is technically not in Cairns, it is consistently voted as Australia’s favourite beach alongside Whitsundays’ favourite Whitehaven Beach. For this reason alone it is worth taking a trip over to Fitzroy Island to experience it for yourself. Most beaches on the island are coral beaches but you can find a sandy beach and swim in crystal clear waters with tropical fish and sea turtles here.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/nudey/nudey-beach-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/nudey/nudey-beach-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/nudey/nudey-beach-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/nudey/nudey-beach-3.jpg',
			  			],
					},

					{
						actId: 1,
						actUrlSegment: 'palm-cove',
						activityTitle: 'Palm Cove',
						activityInfo: 'Palm Cove is a 30 minute drive from the city centre of Cairns and offers a quieter retreat from the city. The beach is the epitome of all that you expect from a tropical beach with palm trees, golden shores and inviting sparkling waters. Visitors can also find restaurants, boutique shops and world class spas that line the beachfront. For a real treat, come here at sunrise or sunset and be amazed by the colourful skyline in front of you.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/palm-cove/palm-cove-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/palm-cove/palm-cove-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/palm-cove/palm-cove-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/palm-cove/palm-cove-3.jpg',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'ellis-beach',
						actQrCode: '',
						activityTitle: 'Ellis Beach',
						activityInfo: 'This beach is the last of Cairns’ Northern Beaches and a great pick for those who are looking for seclusion and solitude as it is the quietest. Apart from a surf life saving club and a campground, there are very little facilities here so perhaps pack a picnic.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/ellis/ellis-beach-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/ellis/ellis-beach-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/ellis/ellis-beach-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/ellis/ellis-beach-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/ellis/ellis-beach-4.jpg',
			  			],
					},

					{
						actId: 3,
						actUrlSegment: 'trinity-beach',
						actQrCode: '',
						activityTitle: 'Trinity Beach',
						activityInfo: 'This beach is a favourite among the locals which means that it must be good! The area does have a few restaurants nearby but is quieter than Palm Cove so it is a great choice for those looking for a less developed area with a couple of facilities nearby.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/trinity-beach/trinity-beach-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/trinity-beach/trinity-beach-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/trinity-beach/trinity-beach-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/trinity-beach/trinity-beach-3.jpg',
			  			],
					},

					{
						actId: 4,
						actUrlSegment: 'four-mile',
						activityTitle: 'Four Mile Beach, Port Douglas',
						activityInfo: 'A day trip to Port Douglas is a must do when you visit Cairns. The town is just 1 hour’s drive from Cairns and has one of the most beautiful beaches in North Queensland. Go for a long walk on the four mile beach taking in the horizon and the mountains of the Great Dividing Range or swim in the protected waters that have lifeguards and stinger nets for a safer swim. ',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/four-mile/four-mile-beach-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/four-mile/four-mile-beach-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/four-mile/four-mile-beach-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/four-mile/four-mile-beach-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/beaches/four-mile/four-mile-beach-4.jpg',
			  			],
					},
				],
	    	},

	    	{
	    		subId: 1,
				subUrlSegment: 'dining',
				subTitle: 'Dining',
				subInfo: '', 
				subDescription: 'Take your taste buds on a first-class (never coach) flight around the globe and indulge in the flavours of the world’s biggest culinary destinations. Featuring the best eats from regions like the Middle East, the Mediterranean, East Asia, and more, our restaurants will have you coming back for more. From the craft beer connoisseur to the strict vodka tonic drinker, our on-site bars know how to whip up all your favourites. Enjoy a new kind of dining experience at one of the many restaurants across our properties in Cairns.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-15.jpg',
				subThumb: '/img/discover-cairns-dining.jpg',
				activities: [	
					{
						actId: 0,
						actUrlSegment: 'paper-crane',
						activityTitle: 'Paper Crane',
						activityInfoBlocks: [
							'Emulating the sights and tastes of Asia, Paper Crane offers a culinary experience like no other.',
							'Taking advantage of tropical Queensland’s fresh produce, the modern Asian inspired menu instantly transports you to the bustling streets of South East Asia.',
						],
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-10.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-10.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-11.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-12.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-13.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-14.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-15.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/paper-crane/paper-crane-8.jpg',
			  			],
			  			activityRestaurantLogo: 'https://cdn.experienceoz.com.au/assets/images/logo/papercrane.png',
			  			activityRestaurantInfo: [
							'Aromatic Asian flavours are accented throughout the dishes, from the aromatic ginger, chilli and shallot mud crab to the sumptuously sweet panadan sugar and coconut pancakes. Say no more!',
							'The theatre of the kitchen extends to the dining room where whole crustaceans and large cuts are shared and presented table side.',
							'Thirsty? There are plenty of drinks to keep you hydrated, with wines from all around the globe and a well-rounded collection of beers and ciders. The signature cocktails don’t hurt either.',
							'Neutral tones and raw surfaces are bolstered by strong design details, cementing this uber-cool eatery as a foodie’s nirvana.',
			  			],
			  			activityRestaurant: [
			  				'Local mud crab in Singaporean sweet chilli sauce',
							'Crystalbrook sirloin steak with Thai salad',
							'Paper Crane hoisin duck rolls',
							'Grilled vegetable gyoza with black vinegar',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'rocco',
						activityTitle: 'Rocco',
						activityInfo: '',
						activityInfoBlocks: [
							'Capturing the spirit of Cairns with influences from afar, Rocco is a proud reflection of Mediterranean history mingled with a contemporary take on cuisine.',
							'Embrace the share style food culture of the Mediterranean region by sharing platefuls of fragrant dishes that pack a tasty punch with friends and family. Full disclosure, you might not want to share after your first bite.',
						],
			  			activityThumb: '/img/dining-roco.jpg',
			  			activityImages: [
			  				'/img/dining-roco.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/rocco/rocco-12.jpg',
			  				'/img/rocco-13.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/rocco/rocco-14.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/rocco/rocco-9.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/rocco/rocco-10.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/restaurants/rocco/rocco-11.jpg',
			  				
			  			],
			  			activityRestaurantLogo: 'https://cdn.experienceoz.com.au/assets/images/logo/rest_rocco.png',
			  			activityRestaurantInfo:[
							'But Rocco is more than just food alone; you can expect an inspired drinks menu with sophisticated sweet and savoury cocktails and a Rosé list that focuses on Provence-style wine.',
							'Earthy tones and Moroccan prints have set the scene for warm ambience as you get lost in the oasis of greenery and sweeping views. We guarantee that you won’t leave disappointed.',
			  			],
			  			activityRestaurant: [
			  				'Sumac calamari with caramelised limes',
							'Oven roasted eggplant with spiced, roasted tomatoes',
							'Moroccan spiced pumpkin hummus',
							'Falafels with jalapeno sauce and chorizo',
							'Mediterranean platter',
			  			],
					},
				],
	    	},

	    	{
	    		subId: 2,
				subUrlSegment: 'shopping',
				subTitle: 'Shopping & Markets',
				subDescription: 'Find a bargain, unique homemade gift or the perfect holiday memento in Cairns at some of these fantastic shopping centres, outlets, duty free shops and markets.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/cairns/header/shopping.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/thumbnails/thumb-shopping.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'galleria',
						activityTitle: 'DFS Galleria',
						activityInfo: 'DFS Galleria Cairns is where shoppers will find all their favourite high end labels in one convenient location. Burberry, Bvlgari, Calvin Klein, Coach, Dior, Fendi, Fossil, Gucci, Hermes, Louis Vuitton, Marc Jacobs, Michael Kors, Prada, Ralph Lauren are among some of the brands here. Leave space in your suitcase or purchase another with all your duty free shopping.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/galleria/galleria-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/galleria/galleria-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/galleria/galleria-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/galleria/galleria-3.jpg'
			  			],
					},

					{
						actId: 1,
						actUrlSegment: 'cairns-central-shopping-centre',
						activityTitle: 'Cairns Central Shopping Centre',
						activityInfo: 'Cairns Central is the cities largest shopping centre right in the heart of the CBD. Head here to find all your favourite Australian shopping labels, chains, supermarkets and speciality services such as hairdresser, banks, nail salons, doctors, chemists and a food court for budget friendly meals. The shopping centre is open 7 days a week with late night trading on Thursday night and shorter hours on weekends.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/cairns-central/central-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/cairns-central/central-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/cairns-central/central-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/cairns-central/central-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/cairns-central/central-4.jpg'
			  			],
					},
					
					{
						actId: 2,
						actUrlSegment: 'dfo-airns',
						activityTitle: 'DFO Cairns',
						activityInfo: 'Shop till you drop in search of bargains at DFO Cairns. The outlet shopping centre is only a 5 minute drive from Cairns CBD and has over 75 stores selling both Australian and International designer labels at discounted prices.  Grab lunch at the DFO Food Court to re-energise during the shopping spree.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/dfo-cairns/dfo-cairns-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/dfo-cairns/dfo-cairns-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/dfo-cairns/dfo-cairns-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/dfo-cairns/dfo-cairns-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/dfo-cairns/dfo-cairns-4.jpg'
			  			],
					},
					
					{
						actId: 3,
						actUrlSegment: 'cairns-esplanade-markets',
						activityTitle: 'Cairns Esplanade Markets',
						activityInfo: 'Wander on down to the Cairns Esplanade Markets on Saturdays from 8am to 4pm. Browse the collection of market stalls here to see and purchase gifts, trinkets, souvenirs, art and crafts, clothing, pottery, jewellery, skincare, leatherwork and more. The Cairns Esplanade Markets are conveniently located to the Cairns Lagoon and nearby cafes, restaurants and picnic facilities along the waterfront precinct.',
						activityDescription: 'gifts, trinkets, souvenirs, art, craft and music; quality art and crafts, clothing, jewellery, pottery and skincare and leatherwork',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/esplanade-markets/esplanade-markets-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/esplanade-markets/esplanade-markets-1.jpg',
							'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/esplanade-markets/esplanade-markets-2.jpg',
							'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/esplanade-markets/esplanade-markets-3.jpg'
			  			],
					},

					{
						actId: 4,
						actUrlSegment: 'tanks-markets',
						activityTitle: 'Tanks Markets',
						activityInfo: 'The Tanks Art Centre Markets are set in a shady tree-lined location in the Cairns Botanic Gardens. The market showcases the work of artists including arts and crafts, collectables, vintage clothing and local health products. Visitors looking for a bite to eat and entertainment won’t be disappointed either. The markets are held on the last Sunday of the month between April and November.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/tanks-markets/tanks-markets-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/tanks-markets/tanks-markets-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/tanks-markets/tanks-markets-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/tanks-markets/tanks-markets-3.jpg'
			  			],
					},

					{
						actId: 5,
						actUrlSegment: 'kuranda-rainforest-markets',
						activityTitle: 'Kuranda Heritage Markets',
						activityInfo: 'Kuranda is famous for its markets in the rainforest. If you are looking for souvenirs, there are plenty of quirky items and Australiana gifts to be found here. The markets have become a community hub for artists for over 30 years who are just as colourful as the markets and the products that are sold here. From local fashion, hand crafted jewellery, indigenous art, leather works, woodworkers, gemstones, honeys, coffee, fruit, macadamia nuts and many more there is something here for everyone. Kuranda Heritage Markets are open 7 days a week.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/kuranda-markets/kuranda-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/kuranda-markets/kuranda-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/kuranda-markets/kuranda-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/kuranda-markets/kuranda-3.jpg'
			  			],
					},

					{
						actId: 6,
						actUrlSegment: 'palm-cove-markets',
						activityTitle: 'Palm Cove Markets',
						activityInfo: 'Find a myriad of local products on display here attracting both tourists and residents. The Palm Cove markets have stallholders selling quality, handmade products including jewellery, leatherwork, pottery, clothes, skincare, plants and produce plus yummy food.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/palm-cove/palm-cove-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/palm-cove/palm-cove-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/palm-cove/palm-cove-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/palm-cove/palm-cove-3.jpg'
			  			],
					},

					{
						actId: 7,
						actUrlSegment: 'port-douglas-markets',
						activityTitle: 'Port Douglas Markets',
						activityInfo: 'This sleepy town comes alive on Sundays when Port Douglas hosts weekly markets at Anzac Park. Easily the best markets in North Queensland, visitors can wander the busy park wandering up and down the aisles viewing natural and quality handmade products, clothing, artwork and food products from all over the region all with a beautiful backdrop of the Coral Sea. Bring plenty of cash for all of the one of a kind gifts that you will find here.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/port-douglas/douglas-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/port-douglas/douglas-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/port-douglas/douglas-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/port-douglas/douglas-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/port-douglas/douglas-4.jpg'
			  			],
					},

					{
						actId: 8,
						actUrlSegment: 'stockland-shopping-centre',
						activityTitle: 'Stockland Cairns Shopping Centre',
						activityInfo: 'Stockland Cairns is an easy 15 minute drive from the city centre. Shoppers will find a number of large department stores, essential services and supermarkets here. Woolworths, Target, Coles, Big W and Birch Caroll and Coyle Cinemas are the premier stores here plus a number of smaller clothing chains and food outlets. The centre is open 7 days a week including late night trading on Thursdays till 9pm.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/stocklands/stocklandcairns-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/stocklands/stocklandcairns-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/stocklands/stocklandcairns-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/shopping-markets/stocklands/stocklandcairns-3.jpg'
			  			],
					},
				],
	    	},

	    	{
	    		subId: 4,
				subUrlSegment: 'arts-culture',
				subTitle: 'Arts & Culture',
				//subInfo: '',
				subDescription: 'Whether you seek entertainment or a thought provoking art exhibit, there is a creative space for you in Cairns. Head to the theatre, discover a one of a kind live music venue and unearth the art galleries that reflect the spirit and cultures of the people who live here.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/cairns/header/arts-culture.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/thumbnails/arts-culture.jpg',
				activities: [

					{
						actId: 0,
						actUrlSegment: 'cairns-performing-arts-centre',
						activityTitle: 'Cairns Performing Arts Centre',
						actQrCode: 'https://www.cairns.qld.gov.au/CPAC/events',
						qrCodeOnly: true,
						activityInfo: "At the Cairns Performing Arts Centre (CPAC) you will witness innovative and debut performances in addition to a well-crafted mix of classics and revived theatrical pieces. With multiple performance spaces across the CPAC site, the versatility of the venue enables the presentation of a variety of events including theatre, music, dance, contemporary circus, opera, film and comedy. Our program of events aims to a focus on youth, new collaborations and our local performing artists alongside a wide range of touring productions. CPAC is Cairns Regional Council's leading performing arts venue, we strive to play an integral role in the development and growth of the arts in our region.",
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-performing-arts-centre/centre-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-performing-arts-centre/centre-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-performing-arts-centre/centre-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-performing-arts-centre/centre-3.jpg',
			  			],
					},

					{
						actId: 1,
						actUrlSegment: 'tanks-arts-centre',
						activityTitle: 'Tanks Arts Centre',
						actQrCode: 'https://www.tanksartscentre.com/',
						qrCodeOnly: true,
						activityInfo: 'Tanks Arts Centre is a business unit of Cairns Regional Council, in the Cultural Services Branch.  Situated in the Cairns Botanic Gardens precinct, just 4km north of the city’s CBD, the centre is an iconic and innovative multi-use, contemporary arts facility housed in three converted World War II naval oil storage tanks, and set amidst a lush rainforest backdrop. Tanks combines two main functions, that of a ‘presenter’ organisation offering a range of arts and cultural events and activities to a wide audience, and also as a community cultural development organisation which aims to proactively engage local communities in cultural expression and participation.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/tanks-arts-centre/centre-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/tanks-arts-centre/centre-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/tanks-arts-centre/centre-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/tanks-arts-centre/centre-3.jpg',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'cairns-art-gallery',
						activityTitle: 'Cairns Art Gallery',
						actQrCode: 'https://www.cairnsartgallery.com.au/',
						qrCodeOnly: true,
						activityInfo: "The dream of a public art gallery for Cairns began to take shape in 1979 and over the next 15 years it took the tenacious commitment of Cairns Mayors, Councillors, State Ministers, as well as artists and members of the community to raise over $2 million to repurpose the historic Public Curators Building into an award winning Gallery that was officially opened on 15 July 1995, and now comprises 3 floors of elegantly proportioned gallery spaces. The Gallery programs supports its commitment to present art of national and international significance and enable cross cultural dialogues and the interpretation of the unique history and living cultures of Far North Queensland (FNQ), and our place in the world’s tropic zone.",
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-art-gallery/centre-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-art-gallery/centre-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-art-gallery/centre-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/cairns-art-gallery/centre-3.jpg',
			  			],
					},

					{
						actId: 3,
						actUrlSegment: 'centre-of-contemporary-arts-cairns',
						activityTitle: 'Centre of Contemporary Arts Cairns',
						actQrCode: 'http://www.arts.qld.gov.au/centre-of-contemporary-arts-cairns',
						qrCodeOnly: true,
						activityInfo: 'The Centre of Contemporary Arts (CoCA) Cairns is a theatre, gallery and creative development space that plays a vital role in the thriving Cairns arts scene. Managed by Arts Queensland (AQ), the centre consists of a theatre venue (a 236-seat black box theatre), rehearsal studio, two A-Class galleries, KickArts Gallery Shop, meeting and workshop facilities, as well as Paradiso Cafe Cairns and a theatre bar. The CoCA, located at 96 Abbott Street, is home to resident AQ-funded companies JUTE Theatre Company and KickArts Contemporary Arts, as well as partnering with End Credits Film Club to provide the contemporary cinema program, Unseen Cinema.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/centre-of-contemporary-arts/centre-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/centre-of-contemporary-arts/centre-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/centre-of-contemporary-arts/centre-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/cairns/arts-culture/centre-of-contemporary-arts/centre-3.jpg',
			  			],
					},
				],
			},
	    ],
	},
   
   	// Things to do
	{
	   	id: 2,
	    navTitle: 'Top things to do',
	    urlSegment: 'things-to-do',
	    title: 'Top things to do in and around Cairns',
	    linkHeading: 'What will you do?',
	    categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
	    linkSubTitle: 'Activities/Attractions/Tours',
	    linkInfo: 'Cairns is the ultimate tropical escape with impressive natural beauty and amazing wildlife. Discover the Great Barrier Reef, Daintree Rainforest, Cape Tribulation and Atherton Tablelands with a range of day tours, reef cruises and extreme outdoor activities in a picturesque setting. Choose your adventure here!',
	    linkText: 'Top things to do',
	    linkAvatar: 'https://cdn.experienceoz.com.au/assets/images/bailey/home/thumb/things-to-do-hotair.jpg',
	    categoryHeadImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/things-to-do.jpg',
	    subCategories: [
				
			{
				// Great Barrier Reef Cruises
				subId: 1,
				subUrlSegment: 'great-barrier-reef-cruises',
				subTitle: 'Reef & Island Cruises',
				subDescription: 'Cruise to the Coral Sea to discover the Great Barrier Reef with daily cruises from Cairns. Explore Green Island, Fitzroy Island or Michaelmas Cay on one of our island cruises, or discover the reef without even getting wet on a cruise to an outer reef activity pontoon. View a selection of the best Great Barrier Reef and island cruises below!',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/great-barrier-reef.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/reef-island-cruises.jpg',
				activities: [
					{
			  			actId: 0,
			  			actUrlSegment: 'great-barrier-reef-dive-snorkel',
			  			actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/reef-and-island-cruises',
			  			activityTitle: 'Great Barrier Reef Adventure Dive & Snorkel Cruises',
			  			activityOperator: 'Reef Magic Dreamtime Dive',
			  			activityInfo: 'Visit the Great Barrier Reef on an adventure dive & snorkel cruise from Cairns with the opportunity to visit two or more reef sites in one day! Gear up for an exciting guided snorkel or scuba dive at remote Outer Barrier Reef sites and be amazed by close encounters with large tropical fish, reef sharks and beautiful coral gardens.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/great-barrier-reef-dive-snorkel/reef-dive-1.jpg',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/great-barrier-reef-dive-snorkel/reef-dive-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/great-barrier-reef-dive-snorkel/reef-dive-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/great-barrier-reef-dive-snorkel/reef-dive-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/great-barrier-reef-dive-snorkel/reef-dive-4.jpg',		
						],
						activityPrices: [
							'Adult: From $189',
							'Child: From $99',
							'Family: From $484',

						],
						activityInclusions: [
							'Full Day Outer Great Barrier Reef Tour',
							'Hot & cold buffet lunch',
							'All snorkelling equipment',
							'Guided snorkelling tours',
							'Marine biologist presentations',
							'Morning & afternoon teas',
						],
						//activityUpgrades: [],
						activityHighlights: [
							"Visit multipule outer reef sites",
							"Up to 5 hours snorkelling time",
							"Modern, spacious & air-conditioned catamarans",
							"All equipment supplied",
							"Morning tea, lunch & afternoon tea included", 
							"Marine biologist talks & presentations",
							"Additional activities such as diving, snorkel safaris & helicopter flights available for purchase",
						],
						activityTourtimes: [
							'Cruises depart from the Cairns Reef Fleet Terminal daily from 8am and arrive back in Cairns at approximately 4.30pm. Check-in commences from 7.30am',
						],
						activityLocation: 'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador',
						activityLocationText: 'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
					},	

					{
						actId: 1,
						actUrlSegment: 'marine-world-reef-pontoon',
						activityTitle: 'Great Barrier Reef Pontoon Cruises',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/reef-and-island-cruises',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/Reef-magic.mp4',
						activityInfo: 'Explore the world’s largest coral reef with a full day cruise to an outer Great Barrier Reef activity pontoon. See rare and unique species of marine life and coral from above and below the waters surface with a number of activities suitable for families and non-swimmers such as snorkelling, scuba diving, glass bottom boat rides and a mesmerising underwater observatory.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-3.jpg',
			  			activityLinkText: 'Explore the reef',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/marine-world-reef-pontoon/reef-pontoon-5.jpg',
			  			],
			  			activityPrices: [
			  				'Adult - From $239',
			  				'Child - From $119',
			  				'Family - From $597',
			  			],
			  			activityInclusions: [
			  				'Full day tour to the Outer Great Barrier Reef',
			  				'Hot & cold buffet lunch',
			  				'Guided snorkelling tours',
			  				'All snorkelling equipment supplied', 
			  				'Marine biologist presentations',
			  				'Morning & afternoon teas',
			  				'Underwater Observatory',
			  				'Glass bottom boat tours',
			  				'Semi Submersible tours',
			  			],
			  			// activityUpgrades: [],
			  			activityHighlights: [
			  				'Up to 5 hours on the reef',
			  				'Spacious activity platform',
			  				'All equipment supplied',
			  				'Morning tea, lunch & afternoon tea included',
			  				'Marine Biologist talks & presentations',
			  				'Additional activities such as diving, snorkel safaris & helicopter flights available for purchase',
			  			],
			  			activityTourtimes: [
			  				'Cruises depart from the Cairns Reef Fleet Terminal daily from 9am and arrive back in Cairns at approximately 5pm. Check in commences from 8am.' ,
			  			],
			  			activityLocationText: 'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
			  			activityLocation: 'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},

					{
						actId: 2,
						actUrlSegment: 'reef-sailing-cruises',
						activityTitle: 'Great Barrier Reef Sailing Cruises',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/reef-and-island-cruises',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/reef-sailing-cruise.mp4',
						activityInfo: "See the best of the Great Barrier Reef in style and comfort with this sailing cruise from Cairns aboard a purpose-built sailing and brand new catamaran! Live the life of luxury aboard a wonderful vessel while surrounded by the spectacular azure blues and emerald greens of Australia's most famous natural icon as we head out to two stunning outer reef locations where you'll have the opportunity to snorkel with all the marine life, take part in scuba diving or simply relax on the spacious foredeck and soak up the sunshine - the choice is yours.",
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-1.jpg',
			  			activityLinkText: 'Explore the reef',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/reef-cruises/sailing-cruise/sailing-cruise-5.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $189',
							'Child: From $125',
							'Family: From $559',
			  			],
			  			activityInclusions: [
			  				'Full day Great Barrier Reef Sailing Cruise',
							'Snorkelling tuition',
							'Tropical hot and cold buffet lunch',
							'Guided snorkel tour',
							'Morning tea with freshly brewed coffee and muffins',
							'Afternoon Tea with a cheese platter',
							'Scuba diving demonstration',
			  			],
			  			activityHighlights: [
							'Visit two premium reef locations',
							'Soak in the sun whilst staring across the magical crystal waters',
							'Dive into the water to cool off and swim amongst turtles, colourful fish and see an amazing variety of corals',
							'Hot and cold buffet lunch including local prawns',
							'Knowledagable and friendly crew ',
			  			],
			  			activityTourtimes: [
			  				'Cruises depart from the Cairns Reef Fleet Terminal daily from 8am and arrive back in Cairns at approximately 5pm. Check-in commences from 7.15am.',
			  			],
			  			activityLocationText: 'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
			  			activityLocation: 'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},
					
					{
			  			actId: 3,
						actUrlSegment: 'fitzroy-island',
						activityTitle: 'Fitzroy Island',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/reef-and-island-cruises',
						//activityOperator: 'Raging Thunder Adventures',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/fitzroy-island-video.mp4',
						activityInfo: 'Spend a half or full day visiting Fitzroy Island in the Great Barrier Reef. Enjoy free time to explore this tropical paradise, swim and snorkel with turtles, view the fringing coral reefs on a glass bottom boat tour, join short nature walks and relax on stunning golden beaches or be really active and hire paddle skis, sea kayaks or bounce into the warm waters from the giant ocean trampoline.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-2.jpg',
			  			activityLinkText: 'Explore the reef',
			  			activityImages: [
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-1.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-2.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-3.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-4.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-5.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-6.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-7.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/fitzroy-island/fitzroy-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult - From $79',
			  				'Child - From $49',
			  				'Family - From $212',
			  			],
			  			activityInclusions: [
			  				'Half or full day on Fitzroy Island',
							'Return ferry transfers from Cairns',
							'FREE use of the Ocean Trampoline',
							'Up to 5 hours to explore the island',
							'Optional activities such as snorkelling, glass bottom boat tours, sea kayaks and paddle skis available for purchase',
			  			],
			  			activityUpgrades: [
			  				'Lunch',
			  				'Glass Bottom Boat Tour',
			  				'Snorkelling Equipment',
			  				'Kayaking Equipment',
			  			],
			  			activityHighlights: [
			  				'Snorkel directly from the beach',
							'Enjoy bushwalks through the island’s rainforests',
							'See the abundant marine life',
							'Only 45 minutes from Cairns',
							'FREE use of the ocean trampoline',
							'Optional activities such as snorkelling, glass bottom boat tours, sea kayaks and paddle skis available for purchase',
			  			],
			  			activityTourtimes: [
			  				'Half day tours depart from Cairns Reef Fleet Terminal daily at 11am and arrive back in Cairns at approximately 2.45pm, and full day tours depart daily at 9am and arrive back in Cairns at approximately 5.15pm.',
			  			],
			  			activityLocation: 'Tours depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
			  			activityLocationInfo: 'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},

					{
						actId: 4,
						actUrlSegment: 'island-tours',
						activityTitle: 'Green Island',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/reef-and-island-cruises/green-island-tours',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/bigcat-video.mp4',
						activityInfo: 'Green Island is a unique coral cay island with rainforests and sandy beaches right in the heart of the Great Barrier Reef.  In just 45 minutes you will be at this tropical island with up to 5 hours to explore the coral cay. Enjoy rainforest walks and snorkelling amongst marine life in the coral reefs surrounding the island. Passengers can choose between free snorkelling gear or a glass bottom boat tour to explore the coral reefs.',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-9.jpg',
			  			activityText: 'Explore the reef',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-1.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-2.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-3.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-5.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-8.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-9.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-10.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-11.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-12.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-13.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-14.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-15.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/green-island/greenisland-16.jpg',
			  			],
			  			activityPrices: [
			  				'Adult - From $97',
			  				'Child - From $48.50',
			  				'Family - From $242.50',
			  			],
			  			activityInclusions: [
			  				'Half or full day on Green Island',
							'Return ferry transfers from Cairns',
							'FREE choice of snorkelling gear or a glass bottom boat tour',
							'Snorkelling demonstration and reef presentation',
							'Up to 5 hours to explore the island',
							'Optional activities such as scuba diving and helicopter flights available for purchase ',
			  			],
			  			//activityUpgrades: [],
			  			activityHighlights: [
			  				'Snorkel directly from the beach',
							'Enjoy bushwalks through the island’s rainforests',
							'See the abundant marine life',
							'Only 45 minutes from Cairns',
							'Optional activities such as scuba diving and helicopter flights available for purchase',
			  			],
			  			activityTourtimes: [
			  				'Half day tours depart from Cairns Reef Fleet Terminal daily at 9am and 1pm and arrive back in Cairns at approximately 1pm and 5pm, and full day tours depart daily at 9am and 11am and arrive back in Cairns at approximately 5pm.',
			  			],
			  			activityLocation: 'Tours depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
			  			activityLocationInfo: 'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},

					{
						actId: 5,
						actUrlSegment: 'michaelmas-cay',
						activityTitle: 'Michaelmas Cay',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/great-barrier-reef',
						//activityVideo: '',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-1.jpg',
						activityInfo: 'Michaelmas Cay is an idyllic tropical island and wildlife haven within the Great Barrier Reef surrounded by fringing coral reefs just waiting to be explored. For your chance to experience this incredible island, jump on a relaxing island sailing cruise from Cairns.  Spend an entire day sailing through the calm clear waters and anchor at Michaelmas Reef. You will have 4 hours here to snorkel the reef amongst spectacular aquatic life, lounge on the sandy shores and cruise on the semi-submersible vessel to see tropical fish and coral gardens galore.  Your memories of Michaelmas Cay will last a lifetime. Book an unforgettable day on the Cay here!',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/island-cruises/michaelmas-cay/michaelmas-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $206',
							'Child: From $105',
							'Family: From $517',
			  			],
			  			activityInclusions: [
			  				'Full day Michaelmas Cay sailing cruise',
							'Morning and afternoon tea',
							'Hot & cold buffet lunch',
							'All snorkelling equipment',
							'Marine biologist presentations',
							'Guided nature tours of the island',
							'Semi Submersible tours',
			  			],
			  			activityHighlights: [
			  				'Up to 4 hours on Michaelmas Cay',
							'Luxury sailing catamaran',
							'Delicious hot & cold buffet lunch with seafood',
							'Morning & afternoon tea included',
							'Spectacular snorkelling',
							'Marine Biologist presentation',
							'Semi Submersible tour for a divers view',
			  			],
			  			activityTourtimes: [
			  				'Cruises depart from the Cairns Reef Fleet Terminal daily from 8.30am and arrive back back in Cairns at approximately 5pm. Check-in commences from 8am.',
			  			],
			  			activityLocationBlocks:[
			  			 	'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns.',
			  			 	'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador.',
			  			 ],
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},
				],
   			},

   			{
   				// Indigenous & Cultural Experiences
   				subId: 2,
				subUrlSegment: 'indigenous-experiences',
   				subTitle: 'Indigenous Experiences',
   				subDescription: 'Discover more about the world’s oldest living culture during a series of authentic Aboriginal experiences. Indigenous communities welcome visitors in Cairns to come and engage with the stories of the Dreamtime, try your hand at the didgeridoo, taste bush tucker or sit down for an enthralling cultural dance performance. A life changing cultural experience is available right at your fingertips.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/indigenous-experiences.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/indigenous-experiences.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'mossman-gorge-dreamtime-walk',
						activityTitle: 'Mossman Gorge Dreamtime Walk',
						actQrCode: 'https://bailey.experienceoz.com.au/en/port-douglas/dreamtime-gorge-walk',
						//activityVideo: '',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/mossman-gorge/mossman-gorge-1.jpg',
						activityInfo: "Venture into the rainforest and navigate the national park on your own or with a guided 'Dreamtime Walk' tour of the Gorge to learn more about the flora, fauna and indigenous culture.  The Mossman Gorge Centre run shuttle buses to the gorge regularly or take the popular Gorge Circuit and sit by a waterhole listening to the sounds of the Daintree rainforest.",
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/mossman-gorge/mossman-gorge-1.jpg',
							'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/hotel/recommend/mossman-gorge/mossman-4.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $78',
							'Infant: Free',
							'Child: From $38.50',
							'Family: From $194.50',
			  			],
			  			activityInclusions: [
			  				'90 Minute tour',
							'Experienced Indigenous guides',
							'Exclusive access to Kuku Yalanji land',
							'Stories of the Kuku Yalanji culture & traditions',
							'Traditional smoking ceremony',
							'Soap & ochre paint making demonstration',
							'Bush tea & damper',
			  			],
			  			activityHighlights: [
			  				'Intimate group tour (Approx 15 guests)',
							'You are welcomed with a traditional ‘smoking’ ceremony that cleanses and wards off bad spirits',
							'The walk then meanders through stunning rainforest and takes in traditional huts or humpies',
							'Your guide demonstrates traditions like making bush soaps and ochre painting. At the end of the tour enjoy traditional bush tea and damper',
			  			],
			  			activityTourtimes: [
			  				'Tours depart daily at 10am, 11am, 12pm, 1pm & 3pm. Complimentary shuttle bus is available from the Mossman Gorge Centre and will take you to the heart of the Gorge. Departs every 15 minutes, between 8.00am and 5.30pm daily.',
			  			],
			  			activityLocationBlocks:[
			  			 	'Mossman Gorge Centre - 212 Mossman Gorge Rd, Mossman Gorge, QLD 4873',
			  			 	'Complimentary shuttle bus is available from the Mossman Gorge Centre.',
			  			 ],
			  			activityCenterLat: -16.4744606,
			  			activityCenterLong: 145.3475952,
			  			activityMarkerLat: -16.4744606,
			  			activityMarkerLong: 145.3475952,
					},
					{
						actId: 0,
						actUrlSegment: 'dreamtime-dive-snorkel',
						activityTitle: 'Dreamtime Dive & Snorkel',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/dreamtime-great-barrier-reef-cruise',
						//activityVideo: '',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-1.jpg',
						activityInfo: 'Snorkellers and divers will experience two premium outer reef sites. A relaxing five hours to explore and gain a deeper cultural understanding of this diverse ecosystem and our indigenous hertitage. Don’t forget, we are the only cruise which allows you to interact with original clap sticks and fire poles plus get live demonstrations of traditional dances and the didgeridoo.',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/dreamtime-dive-snorkel/reef-cruise-5.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $189',
							'Child: From $99',
							'Family: From $484',
			  			],
			  			activityInclusions: [
			  				'5 full hours on the outer reef',
							'Indigenous welcome to country and acknowledgment',
							'Indigenous sea rangers',
							'Marine biologist presentation',
							'Glass bottom boat tour',
							'All snorkelling equipment',
							'Hot & cold buffet lunch with seafood',
			  			],
			  			activityHighlights: [
			  				'Visit 2 premium outer reef sites',
							'5 full hours on the outer reef',
							'Indigenous welcome to country and acknowledgment',
							'Indigenous sea rangers',
							'Marine biologist presentation',
							'Glass bottom boat tour',
							'Hot & cold buffet lunch with seafood',
			  			],
			  			activityTourtimes: [
			  				'Cruises depart from the Cairns Reef Fleet Terminal daily from 8am and arrive back in Cairns at approximately 4.30pm. Check-in commences from 7.30am.',
			  			],
			  			activityLocationBlocks:[
			  			 	'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns.',
			  			 	'Return hotel transfers are available at an additional cost, please see your Lobby Ambassador.',
			  			 ],
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},

					{
						actId: 3,
						actUrlSegment: 'daintree-dreaming-tour',
						// OLD-LINK
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/tours',
						//activityVideo: '',
						activityTitle: 'Daintree Dreaming Tour',
						activityOperator: 'Adventure North Australia',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-1.jpg',
						activityInfo: "Take part in one of the most traditional Aboriginal activities - the walkabout - with this guided day tour through the wonders of the World Heritage protected Daintree Rainforest! After being picked up from your Cairns accommodation, you'll be taken on an environmental and spiritual journey through this ancient, lush rainforest to iconic Mossman Gorge as your indigenous guide expertly navigates the incredible foliage and takes you to witness the array of local highlights contained within.",
			  			//activityThumb: '',
			  			activityPrices: [
			  				'Adult: From $259',
							'Child: From $240',
							'Family: From $998',
			  			],
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/daintree-dreaming-tour/tour-6.jpg',
			  			],
			  			activityInclusions: [
			  				'Full Day Rainforest Tour',
							'Return hotel transfers',
							'Guided walk with an experienced interpretive indigenous guide',
							'Welcome to country smoking ceremony',
							'Lunch at Mossman Gorge Centre',
							'2 hour coast and cultural walk with a Kubirri Warra clan member',
							'Damper and catch of the day',
			  			],
			  			activityHighlights: [
			  				'Unveil the mystery of both the traditional fishing and gathering grounds of Cooya Beach',
							'Wander through lush rainforest',
							'Experience the pristine waters of the Mossman Gorge',
							'Learn traditional fishing and gathering techniques',
							'Lunch at Mossman Gorge Centre',
							'Traditional welcome to country smoking ceremony',
			  			],
			  			activityTourtimes: ['Tours depart the hotel daily at 7.30am and return at approximately 5.45pm'],
					},

					{
						actId: 4,
						actUrlSegment: 'flames-of-the-forest',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/aboriginal-cultural-dining-experience',
						//activityVideo: '',
						activityTitle: 'Flames of the Forest Aboriginal Cultural Dining Experience',
						activityOperator: 'Flames of the Forest',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-1.jpg',
						activityInfo: "Each Tuesday and Thursday nights the rainforest comes alive with a veritable feast for all the senses! Enveloped by the Daintree Rainforest, these unique natural surrounds provide a magical setting for a cultural dining experience like nowhere else on the planet. This evening of theatre, tropical dining and authentic Aboriginal culture, explored through storytelling and music, is a must-do for anyone interested in history, culture, the rainforest, meeting new people and of course those who love great Australian food!",
			  			//activityThumb: '',
			  			activityPrices: [
			  				'Adult: From $239',
							'Child (6-16 yrs): From $199',
			  			],
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/indigenous-experiences/flames-of-the-forest/dining-experience-6.jpg',
			  			],
			  			activityInclusions: [
			  				'Pre-dinner drinks with canapés and sparkling wine',
							'7 course plattered banquet dinner',
							'Australian sparkling wine, red and white wine, beer and soft drink',
							'Aboriginal Cultural Performance featuring didgeridoo, storytelling and singing',
							'Return hotel transfers',
							'Daintree tea and Tablelands coffee',
			  			],
			  			activityHighlights: [
			  				'Flaming arrival and candle lit forest setting under silk lined marquee with hand made chandeliers',
							'Two local indigenous brothers sharing their remarkable culture',
							'Amazing rainforest setting',
							'7 course plated banquet featuring the best local produce and fine wines',
							'Didgeridoo performance',
							'Aboriginal storytelling and singing',
			  			],
			  			activityTourtimes: ['Tuesday and Thursday nights from 7.30pm to 10.30pm. Transfers commence from 6pm.'],
					},
				],
   			},

   			{
   				subId: 3,
				subUrlSegment: 'day-tours',
   				subTitle: 'Day Tours',
   				subDescription: 'Tropical North Queensland is a traveller’s paradise just waiting to be explored. Join guided day tours to explore Kuranda, the “village in the rainforest” via the Skyrail Rainforest Cableway and Kuranda Scenic Railway, visit 2 world heritage listed national parks on a 4WD tour to Cape Tribulation and the Daintree Rainforest, be amazed by limestone formations and fossilised remains in the Australian Outback at Chillagoe Caves or taste your way around the Atherton Tablelands sampling the best food and wine that the region has to offer.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/day-tours.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/thumb-day-tours.jpg',
				activities: [
					{
						actId: 0,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/tours/kuranda-tours',
						actUrlSegment: 'skyrail-rainforest',
						activityTitle: ' Skyrail Rainforest Cableway & Kuranda Scenic Railway',
						activityOperator: 'Kuranda Tours',
						activityInfo: 'Travel through gorges, past cascading waterfalls and over the treetops for an incredible look at the world’s oldest rainforest. The most popular way to experience Kuranda is by heading up on the historic Kuranda Scenic Railway, spending a few hours exploring Kuranda Village and it’s markets and attractions, then gliding over the canopy on the Skyrail Rainforest Cableway with views of the Barron Gorge, Cairns and the Great Barrier Reef.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/skyrail-rainforest/skyrail-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $148',
			  				'Child: From $78', 
			  				'Family: From $396'
			  			],
			  			activityInclusions: [
			  				'Return hotel transfers',
							'One way journey on the Kuranda Scenic Railway',
							'One way journey on the Skyrail Rainforest Cableway',
			  			],
			  			activityHighlights: [
			  				'Ride the historic Kuranda Scenic Railway',
							'Glide over the rainforest canopy on the Skyrail Rainforest Cableway',
							'Enjoy free time in Kuranda to explore the Heritage Markets and Kuranda Wildlife Attractions',
							'Spectacular views of the Barron Falls and Stoney Creek Falls',
			  			],
			  			activityTourtimes: [
			  				'Tours depart the hotel daily from 7am and 8am and arrive back in Cairns at approximately 2.45pm and 3.45pm',
			  			],
					},

					{
						actId: 1,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/tours',
						actUrlSegment: 'cape-tribulation-daintree',
						activityTitle: 'Cape Tribulation & Daintree Rainforest',
						activityOperator: 'Value Day Tour',
						activityInfo: 'Visit two world heritage listed national parks in just one day. See where the reef meets the rainforest as you walk on Cape Tribulation Beach, see the pristine waters at Mossman Gorge, soak in the views at Alexandra Lookout, dine in a rainforest setting and go croc spotting on the Daintree River.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/cape-tribulation/cape-tribulation-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult - From $201',
			  				'Child - From $127',
			  				'Family - From $635',
			  			],
			  			activityInclusions: [
			  				'Return hotel transfers',
							'Fully guided Cape Tribulation & Daintree Rainforest Tour',
							'Morning tea',
							'Delicious tropical lunch',
							'Guided rainforest walk',
							'Daintree River Cruise',
			  			],
			  			activityHighlights: [
			  				'Mossman Gorge Centre',
							'Cape Tribulation Beach & Boardwalk',
							'Alexandra Lookout',
							'Daintree River Cruise',
							'Daintree Ferry',
							'Lunch in a rainforest setting',
			  			],
			  			activityTourtimes: [
			  				'Tours depart the hotel daily from 7am and arrive back in Cairns at approximately 6.30pm',
			  			],
					},
					
					{
						actId: 2,
						actUrlSegment: 'hartleys-crocodile-adventures',
						activityTitle: 'Hartley’s Crocodile Adventures',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/attractions/hartleys-crocodile-adventure',
						activityOperator: 'Value Day Tours',
						activityInfo: "This half day tour from Cairns will take you to the popular Hartleys Crocodile Adventures park - the best place to see crocodiles in tropical North QLD! This highly regarded wildlife park features not just the largest collection of crocodiles in captivity in Queensland, but also a huge array of other animals such as snakes, kangaroos, wallabies, koalas and much more - the majority of which you'll be able to touch for yourself.",
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-2.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/croc-adventures/croc-adventures-5.jpg',
			  			],
			  			activityPrices: [
								'Adult - From $93',
								'Child - From $50',
								'Family - From $264',
			  			],
			  			activityInclusions: [
								'Return hotel transfers',
								'Entry to Hartley’s Crocodile Adventures',
								'Wetlands cruise',
								'Shows and presentations',
			  			],
			  			activityHighlights: [
								'Hartley’s Crocodile Adventures - the best place to see crocodiles in Tropical Nth Qld',
								'Huge array of wildlife including snakes, kangaroos, wallabies, koalas and more',
								'Plenty of free time to explore the park',
								'Wetlands cruise through the Melaleuca wetlands',
								'Crocodile attack show',
								'Half day afternoon tour - enjoy a sleep in',
			  			],
			  			activityTourtimes: ['Tours depart the hotel daily at approximately 11.30am and return at approximately 5.30pm'],
					},

					{
						actId: 3,
						actUrlSegment: 'outback-chillagoe-caves',
						activityTitle: 'Australian Outback & Chillagoe Caves',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/tours',
						activityInfo: 'Travel into the Queensland Outback on this 4WD adventure and discover a different side to North Queensland. In small groups, you will travel off-road and encounter wildlife at Mareeba Wetlands, the perfect spot for a morning tea and a scenic cruise. As you journey deep into the west, see traditional Aboriginal rock art, visit historic outback towns, enjoy lunch at an Aussie Outback Pub and wander amongst the spectacular limestone formations at the Chillagoe Caves. For an authentic outback Aussie experience- look no further than this Australian Outback and Chillagoe Caves 4WD adventure!',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/chillagoe-caves/chillagoe-caves-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/chillagoe-caves/chillagoe-caves-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/chillagoe-caves/chillagoe-caves-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/chillagoe-caves/chillagoe-caves-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/chillagoe-caves/chillagoe-caves-4.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $205',
							'Child: From $175',
			  			],
			  			activityInclusions: [
			  				'Full day Australian Outback Tour',
							'Return hotel transfers',
							'Morning & afternoon tea',
							'Delicious Aussie Pub Lunch',
							'Chillagoe Caves tour',
			  			],
			  			activityHighlights: [
				  			'Travel off the beaten track down 4WD backroads',
							'Morning tea at Skybury Coffee Plantation',
							'Spot kangaroos, emus, wallabies & wedge-tail eagles',
							'Pass through historic mining ghost towns',
							'Visit the local Aboriginal Rock Art & Balancing Rock',
							'Find fossils in ancient limestone casts',
							'Explore the famous Chillagoe Caves',
							'See the Chillagoe smelter ruins',
							'Enjoy an Aussie lunch in an outback pub',
							'Small group luxury 4WD tour',
			  			],
			  			activityTourtimes: ['Tours depart the hotel on Mondays, Wednesdays & Fridays at approximately 6.50am and return at approximately 6.30pm'],
					},

					{
						actId: 4,
						actUrlSegment: 'outback-tasting-tour',
						activityTitle: 'Atherton Tablelands Food & Wine',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/tours',
						activityOperator: 'Brett’s Outback Tasting Adventures',
						activityInfo: 'Discover the tastes and incredible scenery of Tropical North Queensland on a full day Outback Tasting Tour from Cairns. Showcasing some of the best food and wine of the Atherton Tablelands, this boutique food and wine experience will travel through lush rainforest, banana plantations, coffee plantations, dairy farms and wineries sampling the North QLD food bowl. All food samples plus a morning tea and lunch are included!',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-3.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/day-tours/outback-taste/outback-taste-5.jpg',
			  			],
			  			activityPrices: [
			  				'Per Person (18yrs and over) - From $198',
			  			],
			  			activityInclusions: [
			  				'Return hotel transfers',
							'Fully guided foodie tour',
							'Morning tea',
							'Delicious lunch',
							'Wine and coffee tasting',
							'Chocolate tasting',
			  			],
			  			activityHighlights: [
							'Coffee, Chocolate & Cheese tasting ',
							'Tropical fruits tasting ',
							'Morning Tea and Lunch included ',
							'Small group tour',
							'See the Atherton Tablelands',
			  			],
			  			activityTourtimes: ['Tours depart Cairns at 8.30am and return at approximately 5.30pm.'],
					},
					
				],
   			},

   			{
   				subId: 4,
				subUrlSegment: 'activities',
   				subTitle: 'Activities',
   				subDescription: 'Find your Tropical North Queensland adventure here with a range of activities to suit all ages and thrill levels. View a selection of incredible Cairns experiences below including relaxing horse rides in the country, jet boating through the waterways, canyoning through the rainforest, or get the ultimate adrenaline rush on bungy jumps or skydives from 15,000ft.',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/activities.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/thumb-activities.jpg',
				activities: [

					{
						actId: 0,
						actUrlSegment: 'Skydive',
						activityTitle: 'Skydiving',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities/skydiving',
						activityOperator: 'Skydive Cairns',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/skydiving-video.mp4',
						activityInfo: 'Skydive over Tropical North Queensland and experience incredible panoramic views of Cairns, the Great Barrier Reef and the Daintree Rainforest as you free fall for 60 seconds at exhilarating speeds of 200km an hour. This is one holiday activity you will never forget. Book your Cairns skydive here!',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/skydiving/skydiving-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/skydiving/skydiving-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/skydiving/skydiving-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/skydiving/skydiving-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/skydiving/skydiving-4.jpg',
			  			],
			  			activityPrices: [
			  				'Up to 8,500ft: From $219',
			  				'Up to 15,000ft from $309',
			  			],
			  			activityInclusions: [
			  				'7,000ft or 15,000ft Tandem Skydive',
							'Return hotel transfers',
							'Personalised certificate of achievement',
			  			],
			  			activityHighlights: [
			  				'Australia’s highest jump',
							'Spectacular views of the Great Barrier Reef and Tropical Rainforests',
							'Freefall up to 60 seconds',
							'Reach speeds over 200km per hour',
							'FREE upgrade to photo and video (valued at $20)',
							'Discounts on merchandise',
			  			],
			  			activityTourtimes: [
			  				'Skydives operate daily at regular intervals from 5.30am.',
			  				'Please allow approximately 3 hours for your total skydive experience.',
			  			],
					},

					{
						actId: 1,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities/rafting',
						actUrlSegment: 'White-water-rafting',
						activityTitle: 'White Water Rafting',
						activityOperator: 'Raging Thunder',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/whitewaterrafting-video.mp4',
						activityInfo: 'Gather your mates for a thrilling adventure white water rafting down the rapids in Tropical North Queensland. Book a half day tour paddling down the Barron River to experience one of the best white water rafting rivers in Australia. No experience is necessary, so grab your swimsuit and paddle like mad down the rapids on this fun water sports activity with transport from Cairns included.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-5.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/white-water-rafting/whitewaterrafting-4.jpg',
			  			],
			  			activityPrices: [
			  				'Half day Barron River Rafting: From $115',
			  			],
			  			activityInclusions: [
				  			'Half or full day White Water Rafting experience',
							'Return hotel transfers',
							'All tuition provided',
							'All equipment provided',
							'Afternoon tea on the Barron River Rafting Experience',
			  			],
			  			activityHighlights: [
			  				'Australia’s best rafting experience',
							'Spectacular scenery',
							'Raft through World Heritage listed rainforests',
							'No experience required',
							'All equipment provided',
			  			],
			  			activityTourtimes: [
			  				'Half day Barron River rafting tours depart daily at 2pm and return at 6pm',
			  			],
					},

					{
						actId: 2,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities/bungee-jumping',
						actUrlSegment: 'bungy-jumping',
						activityTitle: 'Bungy Jumping',
						activityOperator: 'AJ Hackett',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/bungy-jumping.mp4',
						activityInfo: 'Adrenalin junkies should look no further than the AJ Hackett Bungy Jump in Cairns. Leap from a 50 metre bungy tower with over 16 jump styles to choose from as you free fall towards the ground below. Enjoy the best views of Cairns and the Great Barrier Reef before you jump from Cairns tallest viewing platform.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-3.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/bungy/bungy-jump-8.jpg',
			  			],
			  			activityPrices: [
			  				'Per Person: From $99', 
			  			],
			  			activityInclusions: [
							'Bungy Jump Certificate',
							'Return hotel transfers',
							'Discounts on merchandise and drinks from the bar',
			  			],
			  			activityHighlights: [
			  				'Spectacular views over Cairns and out to the Great Barrier Reef',
							'Highest viewing platform in Cairns',
							'Over 16 different jump styles',
							'Return hotel transfers included',
							'Bungy Jump certificate included',
							'Licensed bar onsite',
			  			],
			  			activityTourtimes: [
			  				'Bungy Jumps operate daily at regular intervals from 10am to 4pm.',
			  				'Hotel transfers depart at 9am, 11am and 1pm and must be pre-booked.',
			  			],
					},

					{
						actId: 3,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/cairns-jet-boat-ride-experience',
						actUrlSegment: 'jetboating',
						activityTitle: 'Jetboating',
						activityOperator: 'Bad Fishy',
						activityInfo: 'Step aboard Bad Fishy for some high speed jetboating fun along the Cairns Waterways and Trinity Inlet. The 35 minute turbo-charged boat ride will have you screaming out in joy as you experience incredible 360 degree spins, slides & power brakes.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/jetboating/jetboating-5.jpg',

			  			],
			  			activityPrices: [
							'Adult: From $69',
							'Child: From $45',
							'Family: From $195',
			  			],
			  			activityInclusions: [
				  			'Exhilarating 35 minute jet boat ride',
							'Expert commentary and local facts about Trinity Inlet',
			  			],
			  			activityHighlights: [
			  				'35 minute adrenalin packed jet boat ride',
							'Thrilling speeds, slides and spins',
							'Great fun for the whole family',
							'Interesting commentary and facts',
							'Most thrilling way to cool off in Cairns',
			  			],
			  			activityTourtimes: [
			  				'Jetboat rides depart from the Cairns Reef Fleet Terminal daily at 11.30am and 2pm. Check-in commences 30 minutes prior to departure',
			  			],
			  			activityLocation: 'Jetboat rides depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns',
			  			activityCenterLat: -16.919343,
			  			activityCenterLong: 145.778584,
			  			activityMarkerLat: -16.921343,
			  			activityMarkerLong: 145.780584,
					},

					{
						actId: 4,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities',
						actUrlSegment: 'canyoning-experience',
						activityTitle: 'Canyoning',
						activityOperator: 'cairns-canyoning',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/canyoning-video.mp4',
						activityInfo: 'Go Canyoning into the Crystal Cascades and discover one of the best kept local secrets. This tour is a great way to experience the nature of North Queensland with experienced guides. Abseil, jump and slide into waterfalls, rock pools and the rainforest. No experience is necessary and kids as young as 8 can join in on the fun. Book your Cairns Half Day Canyoning experience here!',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-1.jpg',
			  			// activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/canyoning/canyoning-5.jpg',
			  			],
			  			activityPrices: [
			  				'Per Person: From $175',
			  			],
			  			activityInclusions: [
			  				'Half day canyoning adventure',
							'Light lunch and refreshments',
							'Return hotel transfers',
							'All tuition provided',
							'All equipment provided',
			  			],
			  			activityHighlights: [
			  				'Canyoning in the rainforest',
							'Ziplining',
							'Abseiling',
							'Sliding & jumping beside waterfalls',
							'No experience required',
							'Light lunch & refreshments provided',
			  			],
			  			activityTourtimes: [
			  				'Morning tours depart Cairns at 6.30am and return at 12.30pm',
			  				'Afternoon tours depart Cairns at 12pm and return at 6pm',
			  			],
					},

					{
						actId: 5,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities',
						actUrlSegment: 'atv-quad-bike-tour',
						activityTitle: 'ATV/Quad Biking',
						activityOperator: 'Blazing Saddles Adventures',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-1.jpg',
						activityInfo: 'Speed through the rainforest on your own ATV/Quad Bike. This 1.5 hour quad bike adventure includes all equipment and tuition plus transfers from Cairns accommodation. Absolutely no experience is necessary. Book here for a fun way to explore the tropical rainforest and nature trails.',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-1.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-2.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-3.jpg',	
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/atv/atv-quad-5.jpg',
			  			],
			  			activityPrices: [
			  				'Per Person: From $145',
			  			],
			  			activityInclusions: [
			  				'1.5 hours of Quad Biking',
							'Return hotel transfers',
							'Tea & coffee',
							'All tuition and equipment provided',
							'Professional guides',
			  			],
			  			activityHighlights: [
			  				'Zoom along rainforest trails on your own Quad Bike',
							'Small personalised groups',
							'Professional guides',
							'All tuition provided, no experience necessary',
							'Easy to ride and provide the perfect adventure',
			  			],
			  			activityTourtimes: [
			  				'Tours depart the hotel daily at 8.45am, 10.45am and 12.45pm and return at 12pm, 2pm, and 4pm.',
			  			],
					},

					{
						actId: 6,
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities',
						actUrlSegment: 'horse-riding-tour',
						activityTitle: 'Horseriding',
						activityOperator: 'Blazing Saddles Adventures',
						activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/horse-ride/horse-riding-1.jpg',
						activityInfo: 'Get out of the city for a relaxing 1.5 hour horse ride in the Australian bush on a working sugar cane farm.  Enjoy the scenic surrounds on this spectacular rural property complete with an 18 acre billabong to ride the horses along. This Aussie experience includes a billy tea over the campfire and is perfect for all riding abilities.',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/horse-ride/horse-riding-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/horse-ride/horse-riding-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/horse-ride/horse-riding-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/activites/horse-ride/horse-riding-4.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $135',
							'Child: From $105',
			  			],
			  			activityInclusions: [
			  				'1.5 hours of Horse Riding',
							'Return hotel transfers',
							'Tea & coffee',
							'All tuition and equipment provided',
							'Professional guides',
			  			],
			  			activityHighlights: [
			  				'Meander through beautiful bushland and rainforests on horseback',
							'Get in and amongst nature first hand',
							'Horses to suit all ages and riding levels',
							'Perfect for beginners to experienced riders',
							'All tuition provided, no experience necessary',
							'See spectacular bird life and maybe even a croc in the wild',
			  			],
			  			activityTourtimes: [
			  				'Tours depart the hotel daily at 8.45am, 10.45am and 12.45pm and return at 12pm, 2pm and 4pm.',
			  			],
					},
				],
   			},

   			{
   				subId: 5,
				subUrlSegment: 'scenic-flights',
   				subTitle: 'Scenic Flights',
				subLink: '',
				subDescription: 'View incredible scenery from the air with scenic flights over mountain ranges, cascading waterfalls and the heritage listed Great Barrier Reef and Daintree Rainforest. Join helicopter flights, fixed wing planes or peaceful sunrise hot air balloon flights taking in the scenery over Cairns.',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-2.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/thumb-scenic-flights-nautilus.jpg',
				activities: [
					{
						actId: 0,
						actUrlSegment: 'nautilus-aviation',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities/flights',
						activityTitle: 'Scenic Helicopter Flights',
						activityOperator: 'Nautilus Aviation',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/gbr-heli-video.mp4',
						activityInfo: 'Fly up and away on a scenic Great Barrier Reef helicopter flight. From the air, discover the true size and beauty of this world heritage listed Aussie icon. Fly over sand islands, coral cays, and Cairns city with a 30 minute scenic flight. Extended 40 minute flights, take passengers to Arlington Reef and the 60 minute flight includes an incredible flight over both the Great Barrier Reef and the Daintree Rainforest.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-1.jpg',
			  			activityImages: [
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-1.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-2.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-3.jpg',
							'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/nautilus-aviation/nautilus-4.jpg',
			  			],
			  			activityPrices: [
			  				'Flights start from $399 per person',
			  			],
			  			activityInclusions: [
							'30, 40 or 60 minute scenic flights, exclusive flights to your own private island and flights to the Great Barrier Reef.',
							'Return hotel transfers available.',
			  			],
			  			activityHighlights: [
			  				'Spectacular views of the Reef and Rainforest',
							'A birds eye view of Cairns City',
							'Departs from the heart of Cairns City',
							'Informative commentary',
			  			],
			  			activityTourtimes: [
			  				'Helicopter flights depart at regular intervals between 10am and 4pm',
			  			],
			  			activityLocation: 'Helicopter flights depart from Cairns Heliport, 2 Pier Point Rd, Cairns',
			  			activityCenterLat: -16.918252,
			  			activityCenterLong: 145.780524,
			  			activityMarkerLat: -16.918252,
			  			activityMarkerLong: 145.780524,
					},

					{
						actId: 1,
						actUrlSegment: 'hot-air-ballooning',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/30-minute-scenic-hot-air-balloon-flight-cairns',
						activityVideo: 'https://cdn.experienceoz.com.au/videos/hot-air-video.mp4',
						activityTitle: 'Hot Air Ballooning',
						activityOperator: 'Raging Thunder Adventures',
						activityInfo: 'Take to the skies on a peaceful and scenic hot air balloon flight and witness a magical sunrise over Cairns and the Atherton Tablelands. Floating over the Mareeba Valley enjoy the changing scenery from beautiful coastlines, lush hinterland and rural plantations.',
						activityDescription: 'Witness the beauty of Cairns and the Atherton Tablelands from the air on a peaceful hot air balloon flight. This incredible flight takes places at sunrise with the backdrop of the Mareeba Valley. Float above gorgeous coastlines, lush hinterland, rural plantations and wineries to soak in the incredible views. Choose between a 30 minute or extended 60 minute flight followed by a glass of champagne and a hot and cold breakfast in an Aussie bush setting. Hotel transfers are available from Cairns at 4am and returns at 10.30am. An express option returning to Cairns at 8.30am is also available so guests may squeeze in a day trip to the Great Barrier Reef or the rainforest in one day! Please note: A $ 30 Aviation Levy is not included and is payable on the day of the tour.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-9.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-8.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-9.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-10.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-11.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-12.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/hot-air-ballooning/hot-air-13.jpg',
			  			],
			  			activityPrices: [
			  				'Per Person From $249',
			  			],
			  			activityInclusions: [
			  				'Minimum 40 minute hot air balloon flight', 
							'Return hotel transfers',
							'Cross country balloon chase',
			  			],
			  			activityHighlights: [
			  				'Breathtaking views over the Atherton Tablelands',
							'Feel the serenity of floating in a hot air balloon',
							'Experience the excitement of a cross country balloon chase',
			  			],
			  			activityTourtimes: [
			  				'Balloon flights depart daily from the hotel at approximately 4am and return at approximately 10.30am.',
			  			],
					},

					{
						actId: 2,
						actUrlSegment: 'fixed-wing-plane',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/activities/flights',
						//activityVideo: '',
						activityTitle: 'Scenic Plane Flights',
						activityOperator: 'GSL Aviation',
						activityInfo: 'Witness a kaleidoscope of colour on a scenic plane flight over the North Queensland coastline and Great Barrier Reef. Only from the air can you truly appreciate the natural beauty of the world’s largest coral reef.  Get the best vantage point possible on a 40 or 60 minute scenic flight over Cairns, Port Douglas and the Great Barrier Reef.',
						//activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-6.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				// 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-1.jpg',
			  				// 'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-4.jpg',
			  				//'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/scenic-flights/gsl-aviation/gsl-6.jpg',
			  			],
			  			activityPrices: [
			  				'Flights start from $129 per person',
			  			],
			  			activityInclusions: [
			  				'40 or 60 minute scenic flights',
							'Return hotel transfers',
							'Guaranteed window seats',
							'In-flight commentary',
			  			],
			  			activityHighlights: [
			  				'Views of Green Island',
							'Views of Palm Cove',
							'Views of Cairns and Port Douglas',
							'FREE Courtesy Transfers',
							'Guaranteed window seats',
							'In flight pilot commentary',
			  			],
			  			activityTourtimes: [
			  				'Flights depart Cairns Airport daily at 8am, 11am and 1pm and return at 11am, 1pm and 3pm.',
			  			],
			  			activityLocation: 'Flights depart from Cairns Airport, Airport Ave, Cairns',
			  			activityCenterLat: -16.876390,
			  			activityCenterLong: 145.753482,
			  			activityMarkerLat: -16.876390,
			  			activityMarkerLong: 145.753482,
					},
				],
   			},

   			{
   				subId: 6,
				subUrlSegment: 'attractions',
   				subTitle: 'Attractions',
   				subDescription: 'Discover the history, native wildlife and Indigenous culture at a number of Cairns and Kuranda rainforest attractions. Learn more about the Great Barrier Reef with a visit to Cairns Aquarium or zipline over animal enclosures at Cairns ZOOM and Wildlife Dome. Don’t forget to visit Kuranda Rainforestation, Birdworld, Koala Gardens, Butterfly Sanctuary or Hartley’s Crocodiles Adventures whilst in Cairns.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/attractions.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/attractions.jpg',
				activities: [
					{
						actId: 2,
						actUrlSegment: 'cairns-aquarium',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/cairns-aquarium-entry-tickets',
						//activityVideo: '',
						activityTitle: 'Cairns Aquarium',
						activityOperator: 'Cairns Aquarium',
						activityInfo: 'Visit the Cairns Aquarium and spend the day exploring Tropical North Queensland’s two world heritage listed zones. The aquarium is fun for all ages with over 15,000 animals on display. Walk through 10 different ecosystems including the reef and the rainforest. Discover the wonderful animals of the world’s most ancient rainforest as well as the curious and colourful marine life that live on the coral reef.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-2.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/aquarium/aquarium-7.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $44',
							'Child: From $29',
							'Family: From $132',
			  			],
			  			activityInclusions: [
			  				'All day admission to Cairns Aquarium',
							'All shows and presentations',
							'BONUS coupons for discounts on retail, photos and tours inside the Aquarium',
			  			],
			  			activityHighlights: [
			  				'Travel through 10 amazing Nth Qld ecosystems',
							'Over 70 different habitats',
							'Discover species from 2 world heritage listed areas',
							'Over 15,000 aquatic animals',
							'Daily shows and presentations',
							'Touch tanks',
							'Onsite restaurant open for breakfast, lunch and dinner',
			  			],
			  			activityTourtimes: [
			  				'Open daily from 9am to 5pm. Last admissions are at 4pm',
			  			],
			  			activityCenterLat: -16.918294,
			  			activityCenterLong: 145.773674,
			  			activityMarkerLat: -16.918294,
			  			activityMarkerLong: 145.773674,
			  			activityLocation: 'Cairns Aquarium is located at 5 Florence St, Cairns',
					},

					{
						actId: 4,
						actUrlSegment: 'cairns-zoom-and-wildlife-dome',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/attractions',
						//activityVideo: '',
						activityTitle: 'Cairns ZOOM and Wildlife Dome',
						activityOperator: 'Cairns ZOOM and Wildlife Dome',
						activityInfo: 'Visit the Cairns ZOOM and Wildlife Dome and interact with a number of wildlife including birds, reptiles, mammals and cuddly Koalas. The dome offers some unique animal experiences including photos with Koalas, Snakes and Crocodiles and thrilling zip lines, tower jumps and dome climbs over crocodile enclosures and bird aviarys.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-8.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/zoom/zoom-9.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $25',
							'Child: From $12.50',
			  			],
			  			activityInclusions: [
							'General admission to Cairns ZOOM & Wildlife Dome',
							'All shows & presentations',
							'Ticket is valid for re-entry all day and for the following 4 days',
			  			],
			  			activityHighlights: [
			  				'Discover the sights and sounds of rainforest life in the heart of the City',
							'Reptile presentations',
							'Koala talks',
							'Crocodile shows',
							'Animal feeding presentations',
							'Zip line courses and rope climbing (optional extra)',
			  			],
			  			activityTourtimes: [
			  				'Cairns ZOOM and Wildlife Dome is open daily from 9am to 6.15pm. Last admissions is at 5pm.',
			  			],
			  			activityCenterLat: -16.923326,
			  			activityCenterLong: 145.779437,
			  			activityMarkerLat: -16.923326,
			  			activityMarkerLong: 145.779437,
			  			activityLocation: 'Cairns ZOOM and Wildlife Dome is located at The Reef Hotel Casino, 35-41 Wharf St, Cairns',
					},

					{
						actId: 5,
						actUrlSegment: 'paronella-park',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/paronella-park-general-admission',
						//activityVideo: '',
						activityTitle: 'Paronella Park',
						activityOperator: 'Paronella Park',
						activityInfo: 'Visit Paronella Park in North Queensland and discover Jose Paronella’s dream to build a castle by Mena Creek Falls in the rainforest. Wander through the grounds and feel like you have stepped into a fairy tale with buildings surrounded by lush rainforest, bridges, tunnels, remarkable architecture, wildlife and picnic grounds by the falls. Admission tickets include a 45 minute guided tour of the park. Don’t miss out on a visit to this incredible attraction.',
						//activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/paronella/paronella-park-6.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $49',
							'Child: From $27',
							'Family: From $142',
			  			],
			  			activityInclusions: [
			  				'General admission to Paronella Park',
							'45 minute guided tour',
							'Souvenir guide book and map',
			  			],
			  			activityHighlights: [
			  				'Fantastic photo opportunities',
							'Remarkable architecture',
							'5 hectares of tropical gardens',
							'Wildlife and fish feeding',
							'45 minute guided storytelling tour',
							'Fully restored and operational 1930’s hydro electric generator',
			  			],
			  			// activityFacilities: [],
			  			activityTourtimes: [
			  				'Paronella Park is open daily from 9am to 7.30pm',
			  			],
			  			activityCenterLat: -17.652356,
			  			activityCenterLong: 145.956308,
			  			activityMarkerLat: -17.652356,
			  			activityMarkerLong: 145.956308,
			  			activityLocation: 'Paronella Park is located at 1671 Japponvale Rd, Mena Creek, approximately 120km from Cairns and a 90 minute drive.',
					},

					{
						actId: 6,
						actUrlSegment: 'hartleys-crocodile-adventures',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/attractions/hartleys-crocodile-adventure',
						//activityVideo: '',
						activityTitle: 'Hartley’s Crocodile Adventures',
						activityOperator: 'Hartley’s Crocodile Adventures',
						activityInfo: 'Hartley’s Crocodile Adventures is a wildlife park set amongst a world heritage protected location showcasing powerful crocodiles and is within easy reach of Cairns. This is the best place in North Qld to see crocodiles and other local wildlife. Join a crocodile cruise through the lagoon to spot the crocs or wander the boardwalk in search of Cassowaries, and a host of other wildlife including cuddly Koalas and reptiles.',
						//activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/hartleys/hartleys-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $41',
							'Child: From $20.50',
							'Family: From $102.50',
			  			],
			  			activityInclusions: [
			  				'General admission to Hartley’s Crocodile Adventures',
							'All shows and presentations',
							'Hartley’s Lagoon boat cruise',
			  			],
			  			//activityUpgrades: [],
			  			//activityWhatToBring: [],
			  			activityHighlights: [
			  				'The best place to see crocodiles in Tropical Nth Qld',
							'Boat cruise on Hartley’s Lagoon to see crocodiles and other wildlife',
							'Crocodile feeding',
							'Cassowary feeding',
							'Snake shows',
							'Koala feeding',
							'Crocodile attack show',
							'Wallaby and Quoll feeding',
			  			],
			  			// activityFacilities: [],
			  			activityTourtimes: ['Hartley’s Crocodile Adventures is open daily from 8.30am to 5pm'],
			  			activityCenterLat: -16.663781,
			  			activityCenterLong: 145.563797,
			  			activityMarkerLat: -16.663781,
			  			activityMarkerLong: 145.563797,
			  			activityLocation: 'Hartley’s Crocodile Adventures is located just off the Captain Cook Highway at Wangetti, approximately a 40 minute drive north of Cairns.',
					},

					{
						actId: 7,
						actUrlSegment: 'rainforestation-nature-park',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/attractions/kuranda-attractions',
						//activityVideo: '',
						activityTitle: 'Rainforestation Nature Park',
						activityOperator: 'Rainforestation Nature Park',
						activityInfo: 'Explore the Kuranda Rainforest with a visit to the Rainforestation Nature Park. The park is home to three great attractions including: The Pamagirri Aboriginal Experience, The Koala and Wildlife Park and The Army Duck Rainforest Tour. Learn more about the indigenous culture and wildlife in a natural setting or on an exciting Army Duck Tour.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-4.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/rainforeststation/rainforeststation-6.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $52',
							'Child: From $26',
			  			],
			  			activityInclusions: [
			  				'Admission to Rainforestation Nature Park',
							'Army Duck Tour',
							'Pamagirri Aboriginal Experience',
							'Koala & Wildlife Park',
			  			],
			  			//activityUpgrades: [],
			  			//activityWhatToBring: [],
			  			activityHighlights: [
			  				'Experience the rainforest from a unique perspective aboard a World War 2 Army Duck',
							'Watch traditional Aboriginal dancers',
							'Try your hand at boomerang throwing',
							'See native Australian wildlife including crocodiles, wombats, dingoes, kangaroos and koalas',
			  			],
			  			activityTourtimes: [
			  				'Rainforestation Nature Park is open daily from 9am to 4pm',
			  			],
			  			activityCenterLat: -16.823480,
			  			activityCenterLong: 145.652162,
			  			activityMarkerLat: -16.823480,
			  			activityMarkerLong: 145.652162,
			  			activityLocation: 'Rainforestation Nature Park is located at 1030 Kennedy Highway, Kuranda, approximately a 40 minute drive from Cairns',
					},

					{
						actId: 8,
						actUrlSegment: 'Birdworld',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/birdword-kuranda',
						activityTitle: 'Birdworld Kuranda',
						activityOperator: 'Birdworld Kuranda',
						activityInfo: 'Discover the most diverse collection of bird life right here at Birdworld Kuranda. This interactive bird sanctuary is a must do for animal lovers who are coming to the ‘village in the rainforest’. See and hand feed over 75 species of exotic birds from Australia and abroad in a rainforest setting complete with ponds and waterfalls.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-1.jpg',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-7.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/birdworld/birdworld-8.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $19',
							'Child: From $9.50',
							'Family: From $47.50',
			  			],
			  			activityInclusions: [
			  				'General admission to Birdworld Kuranda',
			  			],
			  			//activityUpgrades: [],
			  			//activityWhatToBring: [],
			  			activityHighlights: [
			  				'One of Australia’s largest collection of free-flying birds',
							'Natural habitat exhibiting over 350 birds',
							'Handfeeding and photo opportunities',
							'The endangered cassowary',
							'Amazonian macaws',
			  			],
			  			// activityFacilities: [],
			  			activityTourtimes: ['Birdworld Kuranda is open daily from 9am to 4pm.'],
			  			activityCenterLat: -16.818935,
			  			activityCenterLong: 145.632534,
			  			activityMarkerLat: -16.818935,
			  			activityMarkerLong: 145.632534,
			  			activityLocation: 'Birdworld Kuranda is located in the Kuranda Heritage Markets, Rob Veivers Drive, Kuranda, approximately a 40 minute drive from Cairns',
					},

					{
						actId: 9,
						actUrlSegment: 'kuranda-koala-gardens',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/koala-garden-general-admission',
						//activityVideo: '',
						activityTitle: 'Kuranda Koala Gardens',
						activityOperator: 'Kuranda Koala Gardens',
						activityInfo: 'Kuranda Koala Gardens is the perfect place to meet and cuddle a Koala and see other Australian wildlife in the heart of the rainforest village. The wildlife park is home to a variety of species including reptiles, Freshwater crocodiles, Kangaroos, Wallabies and more.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/koala-garden/koala-garden-7.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $19',
							'Child: From $9.50', 
							'Family: From $47.50',
			  			],
			  			activityInclusions: [
			  				'General admission to Kuranda Koala Gardens',
			  			],
			  			activityHighlights: [
			  				'Koalas',
							'Freshwater crocodiles',
							'Kangaroos and wallabies',
							'Snakes',
							'Wombats',
							'Lizards and other reptiles',
			  			],
			  			activityTourtimes: ['Kuranda Koala Gardens is open daily from 9am to 4pm.'],
			  			activityCenterLat: -16.819004,
			  			activityCenterLong: 145.632629,
			  			activityMarkerLat: -16.819004,
			  			activityMarkerLong: 145.632629,
			  			activityLocation: 'Kuranda Koala Gardens is located in the Kuranda Heritage Markets, Kuranda, approximately a 40 minute drive from Cairns',
					},

					{
						actId: 10,
						actUrlSegment: 'kuranda-butterfly-sanctuary',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/attractions/kuranda-attractions',
						//activityVideo: '',
						activityTitle: ' Australian Butterfly Sanctuary',
						activityOperator: 'Kuranda Butterfly Sanctuary',
						activityInfo: 'The Australian Butterfly Sanctuary in Kuranda is the largest butterfly aviary in Australia with over 2000 tropical butterflies including the mesmerising blue Ulysses and Cairns Birdwing. Wander through the aviary boardwalk with a tranquil rainforest backdrop. Knowledgeable guides are happy to answer all your questions on complimentary tours of the aviary and behind the scenes laboratory tours.',
						activityDescription: '',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/attractions/butterfly/butterfly-7.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $20',
							'Child: From $10',
							'Family: From $50',
			  			],
			  			activityInclusions: [
			  				'General admission to Australian Butterfly Sanctuary',
							'Guided tours through the flight aviary',
							'Behind the scenes laboratory tour',
			  			],
			  			//activityUpgrades: [],
			  			//activityWhatToBring: [],
			  			activityHighlights: [
			  				'Australia’s largest butterfly aviary and exhibit',
							'Over 2000 tropical butterflies',
							'Guided aviary tours',
							'Behind the scenes laboratory tours',
			  			],
			  			// activityFacilities: [],
			  			activityTourtimes: ['Australian Butterfly Sanctuary is open daily from 9.45am to 4pm'],
			  			activityCenterLat: -16.819608,
			  			activityCenterLong: 145.633126,
			  			activityMarkerLat: -16.819608,
			  			activityMarkerLong: 145.633126,
			  			activityLocation: 'Australian Butterfly Sanctuary is located at 8 Rob vetivers Drive, Kuranda, approximately a 40 minute drive from Cairns.',
					},
				],
   			},

   			{
   				subId: 7,
				subUrlSegment: 'at-night',
   				subTitle: 'Night Activities',
				subLink: '',
				subDescription: 'The fun doesn’t stop when the sun sets in Cairns with a number of evening options to keep the whole family entertained. Experience a unique rainforest dining setting at Flames of the Forest or finish the day in North Queensland with a drink in your hand on a dining cruise.',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/header/at-night.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/thumbnails/thumb-at-night.jpg',
				activities: [
					{
						actId: 1,
						actUrlSegment: 'flames-of-the-forest',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/at-night',
						//activityVideo: '',
						activityTitle: 'Flames of the Forest',
						activityOperator: 'Flames of the Forest',
						activityInfo: "Australia's only rainforest dining experience, Flames of the Forest transports you into a world beyond your imagination so relaxing and uplifting for your soul you will never want to leave. A completely natural evening offering you a once in a lifetime feast for your senses. Choose from two unique dining experiences in the pristine natural environment - the Aboriginal Cultural Experience or the Rainforest Dining Experience whilst enjoying an award winning menu and inspirational entertainment.",
						activityDescription: 'Witness the Daintree Rainforest come along with an incredible Aboriginal Cultural Performance and 7 course candlelit banquet dinner at Flames of the Forest. This tranquil setting is the perfect place to enjoy an evening theatre performance watching the retelling of Aboriginal dreamtime stories, didgeridoo performances and cultural dance and song. Flames of the Forest serve a welcome pre-dinner drink and canapés prior to the evening performance. After the performance, a 7 course banquet of delicious seafood, chicken, beef, salads and desserts is served alongside Australian beer, wines and soft drinks. The Flames of the Forest is an entertaining cultural night out for couples or families who are interested in culture, history, the rainforest and good Australian food. Dinner at Flames of the Forest is from 7.30pm to 10.30pm on Tuesdays and Thursdays with transfers from Cairns commencing at 6pm. Dine in the forest!',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-1.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/at-night/flames-of-the-forest/fotf-6.jpg',
			  			],
			  			activityPrices: [
			  				'Rainforest Dining Experience: From $198',
							'Aboriginal Cultural Experience: From $227',
			  			],
			  			activityInclusions: [
			  				'6 to 7 course dinner',
							'Selection of Australian wines and beers',
							'Live entertainment',
							'Return hotel transfers',
			  			],
			  			activityHighlights: [
			  				'Australia’s only rainforest dining experience',
							'Choose from 2 unique dining experiences in a pristine natural environment',
							'Enjoy an award winning menu accompanied with Australian wines and beers',
							'Fabulous live entertainment',
			  			],
			  			activityTourtimes: ['Transfers depart the hotel at 6pm on Tuesdays, Thursdays and Saturdays and return at approximately 11pm'],
					},
					
					{
						actId: 3,
						actUrlSegment: 'cairns-harbour-cruise-dinner',
						actQrCode: 'https://bailey.experienceoz.com.au/en/cairns/at-night',
						//activityVideo: '',
						activityTitle: 'Cairns Dinner Cruise',
						activityOperator: 'Spirit of Cairns',
						activityInfo: 'A Spirit of Cairns Dinner Cruise is the perfect way to end the day with an evening out on the water enjoying the ocean breeze and a three course dinner! Head outside on the spacious outdoor decks to soak in the city views as you cruise along the trinity inlet at sunset. Kick off the night with a complimentary glass of wine, bubbles or soft drink and savoury nibbles before dinner is served.',
			  			activityThumb: 'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-2.jpg',
			  			//activityLinkText: '',
			  			activityImages: [
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-1.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-2.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-3.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-4.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-5.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-6.jpg',
			  				'https://cdn.experienceoz.com.au/assets/images/things-to-do/dining-cruises/spirit-of-cairns-dinner/dinner-7.jpg',
			  			],
			  			activityPrices: [
			  				'Adult: From $99',
							'Child: from $50',
			  			],
			  			activityInclusions: [
			  				'2.5 hour calm water evening cruise',
							'Complimentary glass of sparkling wine, beer or soft drink on arrival',
							'Delicious 3 course dinner featuring local produce',
							'Live entertainment',
			  			],
			  			//activityUpgrades: [],
			  			// activityWhatToBring: [],
			  			activityHighlights: [
			  				'Delicious 3 course dinner featuring local products',
							'Complimenatry drink upon arrival',
							'2.5 hour calm water cruise',
							'Live entertainment',
							'Luxurious air-conditioned vessel with large outdoor decks',
							'Spectacular mountain and city views',
			  			],
			  			// activityFacilities: [],
			  			activityTourtimes: ['Cruises depart nightly at 6.30pm and returns at 9pm. Check-in commences from 5.45pm.'],
			  			activityCenterLat: -16.921242,
			  			activityCenterLong: 145.780967,
			  			activityMarkerLat: -16.921242,
			  			activityMarkerLong: 145.780967,
			  			activityLocation: 'Cruises depart from the Cairns Reef Fleet Terminal, 1 Spence St, Cairns.',
					},

				],
   			},
   		],
   	},
	
	// Discover Crystalbrook
   {
		id: 3,
		navTitle: 'Discover Crystalbrook',
		urlSegment: 'discover-crystalbrook',
		title: "Introducing Crystalbrook Collection",
		categoryVideo: 'https://cdn.experienceoz.com.au/videos/cb-brand.mp4',
		categoryBg: 'https://cdn.experienceoz.com.au/assets/images/bailey/misc/pattern-bg.png',
		linkInfo: "A portfolio of distinctive hotels in Australia where differences are applauded. Each hotel and resort carries an authentic expression of its location. Add playful designs, a stimulating environment and a passion for fun and you have a uniquely enriching experience.",
		linkText: 'Discover Crystalbrook',
		linkAvatar: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/main.jpg',
		categoryHeadImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/header/main.jpg',
		subCategories: [
			{
				subId: 0,
				subUrlSegment: 'riley',
				subTitle: 'Crystalbrook Riley',
				customStyle: 'riley',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/riley-rebrand-2021.png',
				slogan: 'Living in the moment',
				subDescription: 'Great to meet you, I’m Crystalbrook Riley. Stay with Riley, a five-star luxury hotel in Cairns, and rediscover fun. Live in the moment and indulge in the little luxuries. Leave your worries at check-in and stake your claim by the pool. Welcome to the great escape—stay a while.',
				atAGlance: [
					'311 rooms including seven suites',
					'A variety of restaurant and bar options including modern Asian cuisine at Paper Crane and Cairns highest rooftop bar, Rocco.',
					'1000+ square metre lagoon swimming pool',
					'Meeting space for up to 400 people',
					'Eléme Spa with five treatment rooms',
					'24 hour fitness centre',
					'Parking for all inhouse and meeting guests',
				],
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/riley/hotel-image-1.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/riley.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/riley/hotel-image-2.jpg',
			},

			{
		   		subId: 1,
				subUrlSegment: 'crystalbrook-albion',
				subTitle: "Crystalbrook Albion",
				customStyle: 'albion',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/crystalbrook-albion.png',
				slogan: 'Devastatingly alluring',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: "Welcome, I’m Crystalbrook Albion. Delightfully intimate, devastatingly gorgeous, genuinely original and refreshingly unpretentious, Crystalbrook Albion in Sydney, Australia, is the embodiment of the local experience reimagined for the modern luxury traveller.",
				atAGlance: [
					'35 guest rooms',
					'24-hour host service',
					"Rooftop garden",
					'Magnificent art collection and bespoke design',
					'Light complimentary breakfast',
					'Five minute walk from Central Station',
					'Pet friendly',
					'Surrounded by plenty of trendy pubs, wine bars, coffee joints, fashion boutiques and renowned restaurants',
				],
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/little-albion/hotel-image-1.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/little-albion.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/little-albion/hotel-image-2.jpg',
			},

			{
		   		subId: 2,
				subUrlSegment: 'crystalbrook-byron',
				subTitle: "Crystalbrook Byron",
				customStyle: 'byron',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/crystalbrook-byron.png',
				slogan: 'Escape to nature',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: 'Namaste, I’m Crystalbrook Byron. Nestled in 45-acres of magical subtropical rainforest, Crystalbrook Byron, is a celebration of nature, responsible luxury and the local environment.',
				atAGlance: [
					'#responsibleluxury sustainability initiatives include sourcing 80% of produce within a three-hour drive, no plastic straws and no water bottles',
					'Featuring 92 suites',
					"The Restaurant; drawing on local produce with an Asian-fusion flair",
					'Infinity pool complete with cabanas, day beds and poolside service',
					'Multi-award-winning day spa',
					'24 hour fitness centre',
					'Wedding, event and meeting spaces for up to 150 people',
					'Complimentary Wi-Fi in all public and in-room areas',
				],
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/byron/hotel-image-1.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/byron-at-byron.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/byron/hotel-image-2.jpg',
			},

			{
				subId: 3,
				subUrlSegment: 'crystalbrook-kingsley',
				subTitle: "Crystalbrook Kingsley",
				customStyle: 'kingsley',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/crystalbrook-kingsley.png',
				slogan: '',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: 'An old soul with a fresh twist, Crystalbrook Kingsley is culturally connected, sustainably-led, simply sophisticated and steeped in history. The first five-star hotel to grace Newcastle, Crystalbrook Kingsley sparks vibrant energy and nostalgia in one moment.',
				atAGlance: [
					'130 sophisticated elegantly appointed rooms',
					'Rooftop bar, Romberg\'s ',
					"Rooftop restaurant, Roundhouse",
					'Lobby bar and café with an outdoor terrace, Ms Mary',
					'Unique meeting and event spaces',
					'Fast and free Wi-Fi in all public and in-room areas',
				],
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/kingsley/hotel-image-2.png',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/crystalbook-kingsley.png',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/kingsley/hotel-image-1.png',
			},

			{
				subId: 2,
				subUrlSegment: 'crystalbrook-vincent',
				subTitle: "Crystalbrook Vincent",
				customStyle: 'vincent',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/crystalbrook-vincent.png',
				slogan: '',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: 'Brave, bold and bursting with energy, Crystalbrook Vincent (formerly The Fantauzzo) is locally integrated with an environmentally conscious #ResponsibleLuxury philosophy. Embrace a lively extravaganza of dynamic.',
				atAGlance: [
					'Perfectly situated in the buzzing, bustling and thriving Howard Smith Wharves precinct',
					'166 contemporary rooms and suites',
					"Rooftop pool and bar, Fiume",
					'Authentic Italian fare, Polpetta',
					'Three event and conference spaces that host up to 150 guests seamlessly',
					'On-site parking and close to public transport',
				],
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/vincent/hotel-image-2.png',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/crystalbrook-vincent.png',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/vincent/hotel-image-1.png',
			},	

			{
		   		subId: 3,
				subUrlSegment: 'flynn',
				subTitle: 'Crystalbrook Flynn',
				customStyle: 'flynn',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/flynn-rebrand-2021.png',
				slogan: 'The wild child',
				subDescription: "Hello Sunshine, I’m Crystalbrook Flynn. Fun and energetic, Flynn makes you feel like you’re at the centre of the action – prepare to be entertained.",
				atAGlance: [
					'Five-star hotel featuring 311 rooms',
					"Three levels of restaurants and bars offering Italian cuisine at Flynn’s Italian, market style food and beverages at Boardwalk Social and a boutique Australian Whiskey and Wine bar",
					'24 hour fitness centre',
					'Eléme Day Spa',
					'Meeting spaces for up to 120 people',
					'Self-parking available',
				],
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/flynn/hotel-image-3.png',
				subThumb: '/img/crystalbrook-flynn.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/flynn/hotel-image-4.png',
			},

			{
		   		subId: 4,
				subUrlSegment: 'eleme-day-spa',
   				subTitle: "Eléme Day Spa",
				customStyle: 'eleme',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/eleme.png',
				slogan: 'Nature meets science',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: "Eléme Day Spa's stellar menu is designed to flex, so our therapists can personalise each treatment to best suit you… your body, your skin, your mood on the day of your visit. Say goodbye to the world of fussy and fluffy and think fresh and fabulous and walk out your best, dazzling self.",
				atAGlance: [
					'Located at Crystalbrook Riley',
					'Located at Crystalbrook Flynn',
				],
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/hotel/spa-wellness/eleme-spa/spa-4.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/eleme-day-spa.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/hotel/spa-wellness/eleme-spa/spa-11.jpg',
			},
				
			{
		   		subId: 7,
				subUrlSegment: 'pastoral',
				subTitle: "Pastoral",
				customStyle: 'crystalbrook',
				logo: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/logos/pastoral.png',
				slogan: 'Our Story Begins At Crystalbrook Pastoral',
				categoryVideo: 'https://cdn.experienceoz.com.au/videos/crystalbrooke-collection.mp4',
				subDescription: 'Crystalbrook Station is at the heart of the Collection. As the first purchase made within the group (and its namesake) the station continues to be central to Crystalbrook Collection and its philosophy.',
				subLink: '',
				subImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/pastoral/station-3.jpg',
				subThumb: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/thumbnails/pastoral.jpg',
				activities: [
				],
				bigImage: 'https://cdn.experienceoz.com.au/assets/images/discover-crystalbrook/pastoral/station-5.jpg',
			},
		],
	},
]
